/* Couche FORME (ce chat). Ne s'exécute que si la page est ouverte avec ?style=...
   Le fond (la copy) reste la propriété du chat copywriting : ici on remplace des
   placeholders par de vrais médias et de vrais widgets. */
(function(){

  /* Les conteneurs de grille du fond n'ont pas de classe : sans nom, aucune règle du système
     ne les atteint. On les nomme d'après ce qu'ils contiennent. Appelé deux fois : une fois
     en cours de route, une fois en fin de passe, quand toutes les classes sont posées. */
  function normaliseConteneurs(){
    Array.prototype.forEach.call(document.querySelectorAll('div[style*="display:grid"], div[style*="display: grid"]'), function(g){
      var kids = Array.prototype.slice.call(g.children);
      if (!kids.length) return;
      /* on ne touche NI au mur des médias NI au carrousel de preuves : ils ont leur
         propre disposition. Leur ajouter une classe de grille casse le composant. */
      if (g.querySelector('.media-cell') || g.classList.contains('media-wall')) return;
      if (g.classList.contains('cards') || g.classList.contains('car-wrap') || g.closest('.car-wrap')) return;
      var specs = kids.filter(function(k){ return k.classList.contains('spec-tile'); }).length;
      var cartes = kids.filter(function(k){
        return k.classList.contains('sys-tile') || k.classList.contains('card2') || k.classList.contains('card');
      }).length;
      var images = kids.filter(function(k){
        return k.classList.contains('swap-media') || k.tagName === 'IMG' || (k.children.length === 1 && k.firstElementChild.tagName === 'IMG');
      }).length;
      if (specs === kids.length) g.classList.add('kpis');
      else if (cartes === kids.length) g.classList.add('cards2');
      else if (images === kids.length) g.classList.add('media-grid');
    });
  }

  /* LISTE D'ARGUMENTS : une suite de "titre + explication" est le même objet, qu'elle soit
     écrite en cartes (haut de page) ou en h3 nus (ailleurs). Le fond l'écrit des deux façons
     dans une même page ; on ne garde que le dessin en cartes. */
  function listesDArguments(){
    Array.prototype.forEach.call(document.querySelectorAll('.inner'), function(inner){
      var kids = Array.prototype.slice.call(inner.children);
      var groupes = [], courant = null;
      kids.forEach(function(n){
        if (n.tagName === 'H3') { courant = [n]; groupes.push(courant); return; }
        if (courant && (n.tagName === 'P' || n.tagName === 'UL' || n.tagName === 'OL')) { courant.push(n); return; }
        courant = null;
      });
      /* on ne retient que les suites d'au moins deux groupes qui se touchent */
      var suites = [], suite = [];
      groupes.forEach(function(g, i){
        var precedent = suites.length || suite.length ? suite[suite.length - 1] : null;
        if (!precedent) { suite = [g]; return; }
        var dernierNoeud = precedent[precedent.length - 1];
        if (dernierNoeud.nextElementSibling === g[0]) suite.push(g);
        else { if (suite.length >= 2) suites.push(suite); suite = [g]; }
      });
      if (suite.length >= 2) suites.push(suite);

      suites.forEach(function(s){
        if (s[0][0].closest('.arglist')) return;
        /* DOCTRINE DE COMPOSITION : la carte sert à comparer. On ne met en carte que des
           contenus courts et de longueur voisine. Un raisonnement long reste du texte,
           en pleine largeur de lecture. */
        var longueurs = s.map(function(g){
          return g.reduce(function(n, el){ return n + el.textContent.length; }, 0);
        });
        var mediane = longueurs.slice().sort(function(a, b){ return a - b; })[Math.floor(longueurs.length / 2)];
        var ecart = Math.max.apply(null, longueurs) / Math.max(1, Math.min.apply(null, longueurs));
        if (mediane > 320 || ecart > 2.6) { s.forEach(function(g){ g[0].classList.add('arg-titre'); }); return; }
        var grille = document.createElement('div');
        grille.className = 'arglist';
        s[0][0].parentNode.insertBefore(grille, s[0][0]);
        s.forEach(function(g){
          var carte = document.createElement('div');
          carte.className = 'sys-tile';
          g.forEach(function(n){ carte.appendChild(n); });
          grille.appendChild(carte);
        });
      });
    });
  }



  /* F18 : jamais de rangée bancale. Le nombre de colonnes se déduit du nombre d'éléments :
     3 éléments = 3 colonnes, 4 = 2 colonnes, 6 = 3 colonnes. Quand la dernière rangée est
     incomplète, elle est centrée. Vaut pour TOUTES les grilles du système. */
  /* Typographie française : espace fine insécable devant « : ; ! ? » » et après « « ».
     Le fond écrit une espace ordinaire, qui laisse le navigateur couper juste avant la
     ponctuation : un titre finissait en « … la plus fréquente » / « : la loi et les normes. ».
     Une passe sur tout le texte rendu, donc toutes les pages d'un coup. */
  function espacesFines(racine){
    var w = document.createTreeWalker(racine, NodeFilter.SHOW_TEXT, {acceptNode: function(n){
      var p = n.parentNode && n.parentNode.nodeName;
      return /^(SCRIPT|STYLE|CODE|PRE|TEXTAREA)$/.test(p) ? NodeFilter.FILTER_REJECT : NodeFilter.FILTER_ACCEPT;
    }});
    var n, t, u;
    while ((n = w.nextNode())) {
      t = n.nodeValue;
      u = t.replace(/[ \u00a0]+([:;!?\u00bb])/g, '\u202f$1').replace(/\u00ab[ \u00a0]+/g, '\u00ab\u202f');
      if (u !== t) n.nodeValue = u;
    }
  }

  function equilibreLesGrilles(){
    var grilles = document.querySelectorAll('.arglist, .cards2, .choose, .kpis, .grid6, .media-grid, .logos-groupe');
    Array.prototype.forEach.call(grilles, function(g){
      if (g.closest('.car-wrap')) return;
      var n = Array.prototype.slice.call(g.children).filter(function(c){
        return c.getBoundingClientRect().height > 0;
      }).length;
      if (n < 2) return;
      var cols;
      if (n <= 3) cols = n;
      else if (n % 3 === 0) cols = 3;
      else if (n % 2 === 0) cols = 2;
      else cols = 3;
      if (n > 4 && n % 4 === 0) cols = 4;
      g.style.setProperty('--cols', cols);
      g.classList.add('grille-eq');
      var reste = n % cols;
      g.classList.toggle('reste-1', reste === 1);
      g.classList.toggle('reste-2', reste === 2);
    });
  }

  /* ATELIER : sélecteur d'affichage mobile / tablette / ordinateur. Un vrai cadre à la
     largeur voulue, sinon les media queries ne se déclenchent pas. */
  function selecteurEcran(){
    var q = new URLSearchParams(location.search);
    if (q.get('frame') === '1') { document.documentElement.setAttribute('data-frame', '1'); return; }
    var barre = document.querySelector('.diagbar');
    if (!barre || document.getElementById('ecran-sel')) return;
    var box = document.createElement('div');
    box.id = 'ecran-sel';
    box.innerHTML = '<button data-w="390">Mobile</button><button data-w="834">Tablette</button>' +
                    '<button data-w="0" class="on">Ordinateur</button>';
    barre.appendChild(box);
    var cadre = null;
    box.addEventListener('click', function(e){
      var b = e.target.closest('button');
      if (!b) return;
      Array.prototype.forEach.call(box.querySelectorAll('button'), function(x){ x.classList.remove('on'); });
      b.classList.add('on');
      var w = parseInt(b.getAttribute('data-w'), 10);
      if (cadre) { cadre.remove(); cadre = null; }
      document.body.classList.toggle('en-cadre', w > 0);
      if (!w) return;
      cadre = document.createElement('div');
      cadre.className = 'ecran-cadre';
      var url = location.pathname + location.search + (location.search ? '&' : '?') + 'frame=1';
      cadre.innerHTML = '<iframe src="' + url + '" style="width:' + w + 'px"></iframe>';
      document.body.appendChild(cadre);
    });
  }

  /* PDF feedback design, point 1 : barre noire fixe sur toutes les pages.
     Badge Shield à gauche, les quatre entrées à plat, Commander à droite.
     Le hamburger n'apparaît qu'en dessous de 900px et déplie EXACTEMENT ces quatre
     entrées : ce n'est pas un plan du site, le pied de page tient ce rôle. */
  function barreDuSite(){
    if (document.getElementById('ls-bar')) return;
    /* Contenu arrêté côté copy (navbar-proposition.md) : quatre entrées à plat,
       aucun sous-item, aucun déroulant, et le bouton Commander. */
    var entrees = [
      ['Le bouclier sonore', 'page-de-vente-v1.html'],
      ['La science', 'page-science-recherche-v1.html'],
      ['Cadre légal', 'page-cadre-legal-v1.html'],
      ['Notre histoire', 'page-notre-histoire-v1.html']
    ];
    var ici = ((window.LS_PAGE || location.pathname.split('/').pop()) || '');
    var liens = entrees.map(function(e){
      return '<a href="' + e[1] + '"' + (e[1] === ici ? ' class="on"' : '') + '>' + e[0] + '</a>';
    }).join('');
    var bar = document.createElement('div');
    bar.id = 'ls-bar';
    bar.innerHTML =
      '<div class="lsb-in">' +
        '<a class="lsb-logo" href="page-de-vente-v1.html"><img src="' + window.LS_A + 'logos-groupe__lima-shield-wordmark.png" alt="LIMA SHIELD"></a>' +
        '<nav class="lsb-nav">' + liens + '</nav>' +
        '<div class="lsb-right">' + (window.LS_CART_HTML || '') +
          '<a class="lsb-cta" href="#commander">Commander</a>' +
          '<button class="lsb-burger" aria-label="Menu"><span></span><span></span><span></span></button>' +
        '</div>' +
      '</div>' +
      '<div class="lsb-menu">' + liens + '</div>';
    document.body.insertBefore(bar, document.body.firstChild);
    bar.querySelector('.lsb-burger').addEventListener('click', function(){ bar.classList.toggle('ouvert'); });
  }
  function run(){
    /* largeur réelle de la zone de contenu : les blocs pleine largeur s'y réfèrent au lieu
       de 100vw, qui ignore le menu d'atelier et provoque un défilement horizontal. */
    function poseLargeurPleine(){
      document.documentElement.style.setProperty('--fullw', document.body.clientWidth + 'px');
    }
    poseLargeurPleine();
    window.addEventListener('resize', poseLargeurPleine);
    /* la largeur mesurée à l'exécution du script peut être celle d'un cadre pas encore
       dimensionné (aperçu mobile en iframe) : on la reprend au chargement complet et à
       chaque changement de taille du corps de page, sinon les blocs pleine largeur
       (carrousel de preuves) restent calés sur une largeur fantôme et se coupent. */
    window.addEventListener('load', poseLargeurPleine);
    if (window.ResizeObserver) { new ResizeObserver(poseLargeurPleine).observe(document.body); }
    selecteurEcran();
    barreDuSite();
    var styleName = document.documentElement.getAttribute('data-style') || '';
    var isP2 = styleName === 'projet-2';
    document.body.setAttribute('data-page', ((window.LS_PAGE || location.pathname.split('/').pop()) || '').replace('.html',''));

    /* Section « Comprendre » (Maurice, 2026-09-01) : ces pages n'ont besoin ni de la vitrine
       produit en haut, ni des preuves clients qui défilent en bas, ni du bloc « Ils parlent
       de nous ». Ce sont des pages d'explication, pas des pages de vente. */
    var PAGES_COMPRENDRE = ['page-notre-histoire-v1', 'page-science-recherche-v1', 'page-cadre-legal-v1',
                            'page-accessoires-application-v1', 'page-faq-v1'];
    var estComprendre = PAGES_COMPRENDRE.indexOf(document.body.getAttribute('data-page')) !== -1;
    /* Comparatifs : le propos est la comparaison, pas la vitrine. Pas de galerie e-commerce
       en haut ; une seule photo du produit, dans la section qui le présente. */
    var PAGES_COMPARATIF = ['page-comparer-alarme-v1', 'page-comparer-brouillard-v1', 'page-comparer-cameras-v1',
                            'page-comparer-gardiennage-v1', 'page-comparer-stroboscope-v1'];
    var estComparatif = PAGES_COMPARATIF.indexOf(document.body.getAttribute('data-page')) !== -1;
    function retireSectionDe(el){
      var sec = el && el.closest ? el.closest('section') : null;
      if (sec && sec.parentNode) sec.parentNode.removeChild(sec);
      else if (el && el.parentNode) el.parentNode.removeChild(el);
    }
    if (estComprendre) {
      /* le mur des médias, où qu'il soit dans le fond */
      var repere = Array.prototype.slice.call(document.querySelectorAll('h2')).filter(function(h){
        return /parlent de nous|parle de nous|dans les médias/i.test(h.textContent);
      })[0];
      if (repere) retireSectionDe(repere);
      /* les preuves clients qui défilent */
      var preuve = Array.prototype.slice.call(document.querySelectorAll('h2')).filter(function(h){
        return /recommandent LIMA SHIELD|ils choisissent|témoignages?/i.test(h.textContent);
      })[0];
      if (preuve) retireSectionDe(preuve);
    }

    var all = Array.prototype.slice.call(document.querySelectorAll('.ph'));
    function phByText(sub){ return all.filter(function(el){ return el.textContent.indexOf(sub) !== -1; }); }
    function widgetize(el){
      el.classList.add('widgetized');
      el.textContent = '';
      return el;
    }
    function fillImg(el, src, objPos, height){
      el.classList.add('swap-media');
      el.style.padding = '0';
      el.style.overflow = 'hidden';
      if (height) el.style.height = height;
      var img = document.createElement('img');
      img.src = src; img.alt = '';
      img.style.cssText = 'width:100%;height:100%;object-fit:cover;display:block;border-radius:inherit;' + (objPos ? 'object-position:' + objPos + ';' : '');
      el.textContent = '';
      el.appendChild(img);
    }

    /* == 1. Photo de Cédric Fontaine (plateau du Figaro) == */
    phByText('Cédric Fontaine').forEach(function(el){ fillImg(el, '' + window.LS_A + 'figaro-cedric.png', '50% 30%', '360px'); });

    /* == 2. Photos clients + image produit prix : photo hangar placeholder == */

    Array.prototype.forEach.call(document.querySelectorAll('.pricing .ph'), function(el){
      /* la galerie produit peut vivre dans le bloc prix (home, Maurice 2026-10-08) : elle se construit plus bas */
      if (el.textContent.indexOf('Photo produit pleine largeur') !== -1) return;
      fillImg(el, '' + window.LS_A + 'gallery__g1.jpg', '50% 55%');
    });

    /* == 2b. Photo produit : galerie e-commerce (vraies photos), réutilisable par toute page == */
    function buildGallery(el){
      widgetize(el).classList.add('pgal');
      var shots = ['g1','g2','g3','g4','g5'];
      var html = '<div class="pg-main"><img src="' + window.LS_A + 'gallery__g1.jpg" alt="LIMA SHIELD"></div><div class="pg-thumbs">';
      shots.forEach(function(s, i){
        html += '<img class="' + (i === 0 ? 'on' : '') + '" src="' + window.LS_A + 'gallery__' + s + '.jpg" alt="Vue ' + (i+1) + '">';
      });
      html += '</div>';
      el.innerHTML = html;
      var main = el.querySelector('.pg-main img');
      Array.prototype.forEach.call(el.querySelectorAll('.pg-thumbs img'), function(th){
        th.addEventListener('click', function(){
          main.src = th.src;
          Array.prototype.forEach.call(el.querySelectorAll('.pg-thumbs img'), function(o){ o.classList.remove('on'); });
          th.classList.add('on');
        });
      });
      /* délimitation entre la galerie et la grille : un paragraphe (texte à reprendre côté copy) */
      var note = document.createElement('p');
      note.className = 'pg-note';
      note.textContent = "Un boîtier compact de 29 × 26 × 16 cm pour 7 kg, posé sur un support ou fixé au mur sur sa platine, orienté vers la zone à protéger. Résistant à la poussière et à l'humidité (IP54), il se pose ou s'installe en intérieur comme en zone semi-extérieure, de préférence à mi-hauteur ou en hauteur.";
      el.parentNode.insertBefore(note, el.nextSibling);
    }
    phByText('Photo produit pleine largeur').forEach(buildGallery);

    /* == 2c. La grille des caractéristiques gagne poids et dimensions (fiche technique) == */
    Array.prototype.forEach.call(document.querySelectorAll('.kpis'), function(k){
      ['Environ 7 kg', '29 × 26 × 16 cm', 'Application mobile, télécommande et bouton panique', 'Digicode et badge'].forEach(function(lbl){
        var d = document.createElement('div'); d.textContent = lbl; k.appendChild(d);
      });
    });

    /* == 3. Vrais lauriers (découpés du badge Prix du Public) == */
    Array.prototype.forEach.call(document.querySelectorAll('.laurel-branch'), function(el){
      var left = el.classList.contains('left');
      el.style.transform = 'none';
      var img = document.createElement('img');
      img.src = '' + window.LS_A + 'laurel-' + (left ? 'left' : 'right') + '.png';
      img.alt = '';
      img.style.cssText = 'height:300px;width:auto;display:block;';
      el.textContent = '';
      el.appendChild(img);
    });

    /* == 4. Logos médias « Ils parlent de nous » : SPEC HARMONISATION du fond ==
       Pas de tuiles : logos monochromes posés sur le fond, opacité ~70 %, hauteur optique
       homogène. Logos à fond opaque (JPG) non exploitables en monochrome : nom typographié. */
    /* logos simples (monogrammes carrés) fournis par Maurice : ils remplacent les
       wordmarks larges partout, grille comprise. */
    var mediaLogos = isP2 ? {
      'Le Figaro':'media-figaro-square.png', 'NRJ':'media-nrj-square.png', 'Républik Group':'media-republik-square.png',
      'FFPR':'media-ffpr-color.png', 'France Cryptos':'media-francecryptos-square.png',
      'BlocksTV':'media-blockstv-color.jpg', 'Le Déclic':'media-declic.jpg',
      'Sans Permission':'media-sansperm-color.jpg', 'Olivier Roland':'media-olivier-roland-color.png'
    } : {
      'Le Figaro':'media-figaro.svg', 'NRJ':'media-nrj-mono.png', 'Républik Group':'media-republik-mono.png',
      'FFPR':'media-ffpr-mono.png', 'France Cryptos':'media-francecryptos-mono.png',
      'BlocksTV':'media-blockstv-mono.png', 'Le Déclic':'media-declic-w.png',
      'Sans Permission':'media-sans-permission-w.png', 'Olivier Roland':'media-olivier-roland-round.png'
    };
    /* F35 : bande optique unique. Les wordmarks larges sont plus bas que les marques carrées,
       mais tout tient dans la même cellule et rien ne dépasse. */
    /* PDF point 5 : mur compact. Les marques carrées (NRJ, FFPR, Déclic, BlocksTV,
       Sans Permission, Olivier Roland) montent, les wordmarks larges restent bas. */
    /* tous les logos sont désormais des monogrammes carrés : une seule taille optique */
    var optiqueGlobal = {'Le Figaro':72,'NRJ':72,'Républik Group':72,'FFPR':72,'France Cryptos':72,
                         'BlocksTV':72,'Le Déclic':72,'Olivier Roland':72,'Sans Permission':72};
    function applyMediaLogo(cell, name){
      if (!mediaLogos[name] || cell.getAttribute('data-logo-done')) return;
      cell.setAttribute('data-logo-done', '1');
      cell.classList.add('media-cell');
      var img = document.createElement('img');
      img.src = '' + window.LS_A + 'logos__' + mediaLogos[name];
      img.alt = name; img.title = name;
      img.style.maxHeight = (optiqueGlobal[name] || 44) + 'px';
      if (name === 'Olivier Roland') img.className = 'media-avatar';
      if (/blockstv|declic|sansperm|sans-permission/i.test(mediaLogos[name] || '')) cell.classList.add('boxed');
      img.onerror = function(){ cell.classList.add('media-name'); cell.textContent = name; };
      cell.textContent = '';
      cell.appendChild(img);
    }
    /* toute tuile du site portant un nom de média, quelle que soit sa structure */
    Array.prototype.forEach.call(document.querySelectorAll('.ph'), function(el){
      if (el.classList.contains('widgetized') || el.classList.contains('swap-media')) return;
      var nm = el.textContent.trim();
      if (mediaLogos[nm]) { el.classList.add('widgetized'); applyMediaLogo(el, nm); }
    });
    /* la distinction Prix du Public : le vrai badge */
    Array.prototype.forEach.call(document.querySelectorAll('.ph'), function(el){
      if (el.classList.contains('widgetized')) return;
      if (el.textContent.indexOf('Prix du Public') === -1) return;
      widgetize(el).classList.add('award-tile');
      el.innerHTML = '<img src="' + window.LS_A + 'prix-du-public.png" alt="Prix du Public, La Nuit de la Sécurité Globale">';
      el.removeAttribute('style');
      /* Ce déplacement ne vaut QUE pour le mur des médias, d'où la tuile doit sortir
         pour se centrer au-dessus. Ailleurs, l'image reste où le fond l'a posée :
         une image liée à un titre ne passe jamais avant ce titre (règle du corps de page). */
      var mur = el.parentNode;
      if (mur && mur.parentNode && mur.classList.contains('media-wall')) mur.parentNode.insertBefore(el, mur);
    });

    var h2s = Array.prototype.slice.call(document.querySelectorAll('h2'));
    var mediaH2 = h2s.filter(function(h){ return h.textContent.indexOf('Ils parlent de nous') !== -1; })[0];
    if (mediaH2) {
      var grid = mediaH2.parentNode.querySelector('div[style*="grid"]');
      if (grid) {
        Array.prototype.forEach.call(grid.children, function(cell){
          var name = cell.textContent.trim();
          cell.classList.add('media-cell');
          if (mediaLogos[name]) applyMediaLogo(cell, name);
          else cell.classList.add('media-name');
        });
      }
    }


    /* == Logos des entités du groupe : les vrais écussons, récupérés sur les sites
       officiels (limaprotection.com, limacyber.com, limaluxurycars.com, limashield.com).
       Lima Stratégie n'a pas de logo propre en ligne : la tuile reste en attente. == */
    /* badges officiels du groupe (limagroupe.com), version encre pour les sections claires */
    var entites = {
      'Logo Lima Protection': 'badge-dark-protection.png',
      'Logo Lima Cyber': 'badge-dark-cyber.png',
      'Logo Lima Cars': 'badge-dark-cars.png',
      'Logo Lima Shield': 'badge-dark-shield.png',
      'Logo Lima Groupe': 'badge-dark-groupe.png'
    };
    Array.prototype.forEach.call(document.querySelectorAll('.logos-groupe .ph, .ph'), function(el){
      if (el.classList.contains('widgetized')) return;
      var t = el.textContent.replace(/[\[\]]/g, '').trim();
      if (!entites[t]) return;
      widgetize(el).classList.add('entite-logo');
      el.removeAttribute('style');
      el.innerHTML = '<img src="' + window.LS_A + 'logos-groupe__' + entites[t] + '" alt="' + t.replace('Logo ', '') + '">';
    });
    /* PDF point 23 : l'entité sans logo disponible ne laisse pas de carré. On la retire. */
    Array.prototype.forEach.call(document.querySelectorAll('.logos-groupe .ph'), function(el){
      if (el.classList.contains('widgetized')) return;
      el.remove();
    });

    /* == LIGNE DE LOGOS MÉDIAS, en couleur, tous sur une seule ligne, responsive.
       Posée à la suite du headline complexe, sur la page qui le porte. Uniquement là. == */
    (function ligneDesMedias(){
      var h1 = document.querySelector('h1');
      var pageId = document.body.getAttribute('data-page') || '';
      var surComparatif = /^page-comparer-/.test(pageId);
      if (!h1 || (!/criminalité innove/i.test(h1.textContent) && !surComparatif)) return;
      if (document.querySelector('.media-line')) return;
      var sec = h1.closest('section');
      if (!sec) return;
      /* mêmes proportions optiques que le mur : les marques carrées montent,
         les wordmarks larges restent bas (PDF point 5) */
      /* Tous les médias en monogramme carré : un seul gabarit pour la ligne entière.
         Les trois wordmarks larges (Figaro, France Cryptos, Républik) ont leur version
         simple, fournie par Maurice, ce qui rend la ligne homogène. */
      var couleur = [
        ['Le Figaro', 'media-figaro-square.png', 54], ['NRJ', 'media-nrj-square.png', 54],
        ['Républik Group', 'media-republik-square.png', 54], ['FFPR', 'media-ffpr-color.png', 54],
        ['France Cryptos', 'media-francecryptos-square.png', 54], ['BlocksTV', 'media-blockstv-color.jpg', 54],
        ['Le Déclic', 'media-declic.jpg', 54], ['Olivier Roland', 'media-olivier-roland-color.png', 54],
        ['Sans Permission', 'media-sansperm-color.jpg', 54]
      ];
      var cells = couleur.map(function(m){
        return '<span class="ml-cell"><img src="' + window.LS_A + 'logos__' + m[1] + '" alt="' + m[0] +
               '" title="' + m[0] + '" style="max-height:' + m[2] + 'px"></span>';
      }).join('');
      var bloc = document.createElement('div');
      bloc.className = 'media-line';
      bloc.innerHTML = '<div class="ml-row">' + cells + '</div>';
      var inner = sec.querySelector('.inner') || sec;
      inner.appendChild(bloc);
      /* PDF points 15 et 26 : la ligne remplace la grille. Jamais les deux sur une page. */
      var mursASupprimer = document.querySelectorAll('.media-wall, .logos-groupe ~ .media-wall');
      Array.prototype.forEach.call(mursASupprimer, function(g){
        var sg = g.closest('section');
        if (sg && sg.parentNode) sg.parentNode.removeChild(sg); else g.parentNode.removeChild(g);
      });
      /* la grille peut n'être construite qu'ensuite : on la retire aussi au passage suivant */
      document.documentElement.setAttribute('data-ligne-medias', '1');
    })();

    /* == LIGNE DES ÉCOLES ET INSTITUTIONS : d'où viennent les équipes. Sous le headline
       de la page Science et recherche, et uniquement là. == */
    (function ligneDesEcoles(){
      var h1 = document.querySelector('h1');
      if (!h1 || !/science derrière le bouclier/i.test(h1.textContent)) return;
      if (document.querySelector('.team-line')) return;
      var sec = h1.closest('section');
      if (!sec) return;
      var ecoles = [
        ['Armée de Terre', 'armee.svg', 34], ['HEC Paris', 'hec.svg', 30], ['Groupe Iliad', 'iliad.svg', 26],
        ['ECE Paris', 'ece.png', 30], ['Police nationale', 'police.svg', 30], ['Dassault Aviation', 'dassault.svg', 24]
      ];
      var cells = ecoles.map(function(m){
        return '<span class="tl-cell"><img src="' + window.LS_A + 'logos-equipe__' + m[1] + '" alt="' + m[0] +
               '" title="' + m[0] + '" style="max-height:' + m[2] + 'px"></span>';
      }).join('');
      var bloc = document.createElement('div');
      bloc.className = 'media-line';
      bloc.className = 'team-line';
      bloc.innerHTML = '<p class="tl-lead">Nos équipes viennent d\'eux</p><div class="tl-row">' + cells + '</div>';
      (sec.querySelector('.inner') || sec).appendChild(bloc);
    })();

    /* PDF points 36-37 : la page FAQ n'a pas de section sombre, ni de bloc de logos. */
    if (document.body.getAttribute('data-page') === 'page-faq-v1') {
      var prem = document.querySelector('section');
      Array.prototype.forEach.call(document.querySelectorAll('section.dark'), function(s){
        if (s === prem) return;
        s.classList.remove('dark'); s.removeAttribute('style');
      });
      if (prem) prem.classList.add('dark');
      document.documentElement.setAttribute('data-sans-sombre', '1');
    }

    /* PDF point 25 : les photos d'atelier du dossier « Shield real photos ». */
    var atelier = ['atelier__strasbourg-1.jpg', 'atelier__strasbourg-2.jpg', 'atelier__strasbourg-3.jpg'];
    var ia = 0;
    phByText('Photo atelier Strasbourg').forEach(function(el){
      if (el.classList.contains('swap-media') || el.classList.contains('widgetized')) return;
      fillImg(el, '' + window.LS_A + '' + atelier[ia % atelier.length], '50% 50%', '240px');
      ia++;
    });

    /* PDF point 24 : « Qui le groupe protège » est une section à part, avec son titre. */
    (function sectionQuiProtege(){
      var h = Array.prototype.slice.call(document.querySelectorAll('h3')).filter(function(x){
        return /Qui le groupe protège/i.test(x.textContent);
      })[0];
      if (!h) return;
      var sec = h.closest('section');
      if (!sec) return;
      var nouvelle = document.createElement('section');
      var inner = document.createElement('div');
      inner.className = 'inner';
      nouvelle.appendChild(inner);
      var titre = document.createElement('h2');
      titre.textContent = h.textContent.trim();
      inner.appendChild(titre);
      var n = h.nextElementSibling;
      h.remove();
      while (n) { var suivant = n.nextElementSibling; inner.appendChild(n); n = suivant; }
      sec.parentNode.insertBefore(nouvelle, sec.nextSibling);
    })();

    /* PDF points 4 et 14 : UN seul modèle de widget de garantie — pastille lavée,
       titre en gras, texte. Pas de chiffre-titre en plus : il est déjà dans la phrase. */
    Array.prototype.forEach.call(document.querySelectorAll('.garantie .num'), function(n){ n.remove(); });

    /* PDF point 19 : sur les comparatifs, le bloc de pricing table est repris à la suite
       de l'annonce du prix. Même bloc que la home, mêmes lignes. */
    (function pricingSurComparatif(){
      if (!/^page-comparer-/.test(document.body.getAttribute('data-page') || '')) return;
      if (document.querySelector('.pricebox')) return;
      /* la section du prix se reconnaît à son titre (prix, coût, euros) ou, à défaut,
         au paragraphe qui annonce les 2 500 € HT */
      var h = Array.prototype.slice.call(document.querySelectorAll('h2')).filter(function(x){
        return /prix|coût|€|euros/i.test(x.textContent);
      })[0];
      if (!h) {
        var pEuro = Array.prototype.slice.call(document.querySelectorAll('section p')).filter(function(x){
          return /2\s?500\s?€\s?HT/.test(x.textContent);
        }).pop();
        h = pEuro ? (pEuro.closest('.inner') || {}).querySelector && pEuro.closest('.inner').querySelector('h2') : null;
      }
      if (!h) return;
      var inner = h.closest('.inner');
      if (!inner) return;
      var lignes = ["Une technologie d'inspiration militaire, encadrée pour l'usage civil",
        'Prix du Public de la Nuit de la Sécurité Globale (Républik Group)',
        'Conçu en France par des professionnels de la sécurité',
        'Recommandé par des policiers',
        'Application mobile mise à jour régulièrement',
        "Jusqu'à 1 mois d'autonomie sur batterie",
        'Son calibré 2 à 5 kHz, 86 à 138 dB réglables',
        'Garantie industrielle 2 ans',
        'Support client avec équipe en France',
        'Stock limité'];
      var bloc = document.createElement('div');
      bloc.className = 'pricing';
      bloc.innerHTML =
        '<div class="ph swap-media pricing-photo" style="padding:0;overflow:hidden">' +
        '<img src="' + window.LS_A + 'gallery__g2.jpg" alt="LIMA SHIELD" style="width:100%;height:100%;object-fit:cover;display:block;border-radius:inherit">' +
        '</div>' +
        '<div class="pricebox"><div class="price">LIMA SHIELD<br>2 500 € HT</div><ul>' +
        lignes.map(function(l, i){
          var c = i === 1 ? ' class="p-proof"' : (i === lignes.length - 1 ? ' class="p-urg"' : '');
          return '<li' + c + '>' + l + '</li>';
        }).join('') + '</ul></div>';
      /* juste après le paragraphe qui annonce le prix */
      var apres = h.nextElementSibling;
      while (apres && apres.tagName === 'P' && !/€/.test(apres.textContent)) apres = apres.nextElementSibling;
      if (apres && apres.nextSibling) inner.insertBefore(bloc, apres.nextSibling);
      else inner.appendChild(bloc);
    })();

    /* PDF point 32 : le bouton panique et le clavier sont illustrés par LEURS ICÔNES,
       celles du kit Projet 2 (#remote et #key), pas par un écran d'application entier. */
    (function iconesAccessoires(){
      /* les visuels réels des accessoires, fournis par Maurice */
      var cfg = [
        ['Photo du bouton panique', 'Bouton panique et télécommande', 'telecommande.svg'],
        ['Photo du clavier', 'Clavier et badge', 'clavier.svg']
      ];
      cfg.forEach(function(c){
        phByText(c[0]).forEach(function(el){
          if (el.classList.contains('widgetized') || el.classList.contains('swap-media')) return;
          widgetize(el).classList.add('acc-visuel');
          el.removeAttribute('style');
          el.innerHTML = '<img src="' + window.LS_A + 'accessoires__' + c[2] + '" alt="' + c[1] + '">' +
                         '<b class="acc-lbl">' + c[1] + '</b>';
          /* deux colonnes : le visuel à gauche, le texte de la section à droite */
          var duo = document.createElement('div');
          duo.className = 'acc-duo';
          el.parentNode.insertBefore(duo, el);
          duo.appendChild(el);
          var col = document.createElement('div');
          col.className = 'acc-texte';
          duo.appendChild(col);
          var n = duo.nextElementSibling;
          while (n && !/^H[1-3]$/.test(n.tagName) && !n.classList.contains('acc-duo')) {
            var suivant = n.nextElementSibling;
            col.appendChild(n);
            n = suivant;
          }
        });
      });
    })();

    /* Un logo d'institution posé seul au-dessus d'une citation ne sert à rien : la source
       est déjà nommée dans la citation. On retire le logo, la citation reste le bloc. */
    Array.prototype.forEach.call(document.querySelectorAll('.ph'), function(el){
      if (el.classList.contains('widgetized') || el.classList.contains('swap-media')) return;
      if (!/^\[\s*Logo /i.test(el.textContent.trim())) return;
      var suivant = el.nextElementSibling;
      if (suivant && (suivant.classList.contains('exergue') || suivant.querySelector('.who'))) el.remove();
    });

    /* LE BLOC DE GARANTIES : deux cartes, contenu figé, identique sur toutes les pages.
       Le fond écrit ces textes différemment d'une page à l'autre ; on impose les mêmes. */


    /* Une citation qui porte son attribution (.who) est une CITATION : carte lavée et
       grand guillemet, comme les citations d'autorité. Pas un paragraphe en italique. */
    Array.prototype.forEach.call(document.querySelectorAll('.exergue'), function(q){
      q.classList.add('quote-bloc');
    });

    /* Un couple CTA + jauge n'a rien à faire au milieu d'une section de qualification :
       il se pose APRÈS le dernier argument de la section, jamais entre deux paragraphes. */
    Array.prototype.forEach.call(document.querySelectorAll('.center'), function(bloc){
      if (!bloc.querySelector('a.cta')) return;
      var inner = bloc.closest('.inner');
      if (!inner) return;
      var suivants = [];
      var n = bloc.nextElementSibling;
      while (n) { suivants.push(n); n = n.nextElementSibling; }
      /* s'il reste du texte après le CTA dans la même section, le CTA descend à la fin */
      var duTexte = suivants.some(function(el){ return /^(P|UL|OL|H3|H4|DIV)$/.test(el.tagName) && el.textContent.trim().length > 40; });
      if (duTexte) inner.appendChild(bloc);
    });

    /* deux typologies de garantie seulement : « sans abonnement » n'en est pas une */
    Array.prototype.forEach.call(document.querySelectorAll('.garantie, .card2, .sys-tile, .cards2 > div'), function(c){
      if (/Sans abonnement|Aucun frais mensuel/i.test(c.textContent) && c.textContent.length < 220) c.remove();
    });


    /* LA HOME EST LE MODÈLE : son texte de garantie fait foi sur toutes les pages.
       Le fond des autres pages en écrit une version raccourcie, d'où un bloc qui
       n'était jamais le même d'une page à l'autre. */
    var TEXTE_GARANTIE = {
      'commerciale': "Installez-le, testez-le, vivez avec. S'il ne trouve pas sa place chez vous, nous le reprenons et nous vous remboursons.",
      'technique': 'Pendant 2 ans, si votre LIMA SHIELD présente un défaut ou une panne, nous le réparons ou le remplaçons. Seule la batterie, pièce d\u2019usure, en est exclue. Un simple contact avec notre support suffit : une équipe basée en France établit le diagnostic avec vous et organise la réparation ou l\u2019échange. Au-delà de ces 2 ans, l\u2019appareil est conçu pour durer 10 ans.'
    };
    /* on cible par le CONTENU : sur les autres pages ces cartes ne portent pas la
       classe « garantie », ce sont des cartes ordinaires du fond. */
    Array.prototype.forEach.call(document.querySelectorAll('p, li, div'), function(p){
      if (p.children.length > 2) return;
      var fort = p.querySelector(':scope > strong, :scope > b');
      if (!fort) return;
      var t = fort.textContent;
      var cle = /^Garantie commerciale/i.test(t) ? 'commerciale'
              : /^Garantie technique/i.test(t) ? 'technique' : null;
      if (!cle) return;
      if (p.textContent.indexOf(TEXTE_GARANTIE[cle].slice(0, 24)) !== -1) return;
      p.innerHTML = '<strong>' + t.trim() + '</strong> ' + TEXTE_GARANTIE[cle];
      if (!/:/.test(t)) {
        var d = cle === 'commerciale' ? '30 jours' : '2 ans';
        p.querySelector('strong').textContent = t.replace(/\s*\.\s*$/, '') + ' : ' + d;
      }
    });

    /* == 5. Logos « Nos équipes viennent de » (Wikimedia Commons) == */
    var team = {
      'Armée française':'armee.svg', 'HEC Paris':'hec.svg', 'Groupe Iliad':'iliad.svg',
      'ECE Paris':'ece.png', 'Police nationale':'police.svg', 'Dassault':'dassault.svg'
    };
    Array.prototype.forEach.call(document.querySelectorAll('.logos span'), function(sp){
      var name = sp.textContent.trim();
      if (!team[name]) return;
      sp.classList.add('team-tile');
      var label = name;
      var img = document.createElement('img');
      img.src = '' + window.LS_A + 'logos-equipe__' + team[name];
      img.alt = label; img.title = label;
      img.onerror = function(){ sp.textContent = label; };
      sp.textContent = '';
      sp.appendChild(img);
    });

    /* == 6. Effet de rareté : jauge de stock == */
    phByText('Effet de rareté').forEach(function(el){
      widgetize(el).classList.add('rarity-w');
      if (isP2) {
        el.innerHTML = '<div class="rw-slider"><i style="width:14%"></i></div>' +
          '<div class="rw-line"><span class="rw-a">Plus que <b>' + (window.LS_STOCK_TXT || '38 unités disponibles') + '</b></span>' +
          '<span class="rw-sep"> · </span><span class="rw-b">prochaine production novembre 2026</span></div>';
        return;
      }
      var segs = '';
      for (var i = 0; i < 20; i++) segs += (i < 18) ? '<i></i>' : '<i class="ok' + (i === 19 ? ' blk' : '') + '">✓</i>';
      el.innerHTML = '<div class="rw-bar2">' + segs + '</div><div class="rw-line"><span class="rw-a">PLUS QUE <b>' + (window.LS_STOCK_TXT || '38 unités disponibles').toUpperCase() + '</b></span>' +
        '<span class="rw-sep"> · </span><span class="rw-b">PROCHAINE PRODUCTION NOVEMBRE 2026</span></div>';
    });

    /* == 7. Ondes sonores animées : le cycle de dissuasion, raconté ==
       Boucle : sommation par bips sonores -> saturation qui monte jusqu'aux 138 dB -> arrêt automatique.
       Le niveau affiché est calculé sur les barres réelles : le widget ne se contredit jamais. */
    phByText('ondes sonores animées').forEach(function(el){
      widgetize(el).classList.add('spectrum-w');
      var N = 24;
      var html = '<div class="sw-head"><i></i>CYCLE DE DISSUASION<span class="sw-phase">SOMMATION PAR BIPS</span></div><div class="sw-plot">';
      html += '<div class="sw-th t138"><span>138 dB</span></div><div class="sw-th t120"><span>120 dB</span></div>';
      for (var i = 0; i < N; i++) html += '<div class="sw-col"><b style="height:8%"></b></div>';
      html += '</div><div class="sw-x"><span>2 kHz</span><span>3 kHz</span><span>4 kHz</span><span>5 kHz</span></div>';
      html += '<div class="sw-foot"><span class="sw-lab">NIVEAU INSTANTANÉ<small>Réglable de 86 à 138 dB</small></span><span class="sw-level"><b>86</b><small>dB</small></span></div>';
      el.innerHTML = html;
      var bars = el.querySelectorAll('.sw-col b');
      /* La couleur d'une barre dépend de SA hauteur, pas de sa position dans la série :
         verte en bas, jaune à mi-course, rouge en haut. Elle change donc progressivement
         quand la barre monte et quand elle redescend. */
      function colore(bar, h){
        bar.classList.remove('lvl-bas', 'lvl-mid', 'lvl-haut');
        bar.classList.add(h < 34 ? 'lvl-bas' : (h < 66 ? 'lvl-mid' : 'lvl-haut'));
      }
      var level = el.querySelector('.sw-level b');
      var levelWrap = el.querySelector('.sw-level');
      var phase = el.querySelector('.sw-phase');
      /* profil d'enveloppe : l'émetteur pousse plus fort au centre de la bande */
      var mult = [], peakVals = [];
      for (var j = 0; j < N; j++) {
        mult.push(.72 + .28 * Math.sin(Math.PI * j / (N - 1)) + (Math.random() - .5) * .08);
        peakVals.push(0);
      }
      var CYCLE = 9000, start = Date.now(), lastHit = 0;
      /* correspondance hauteur -> dB : la ligne 120 est à 66 % (top:34%), 138 à 100 %.
         L'ancienne formule (43 + h) affichait jusqu'à 140 dB, au-dessus du maximum réglable. */
      function toDb(h){ return Math.min(138, Math.round(120 + (h - 66) * 18 / 34)); }
      setInterval(function(){
        var t = (Date.now() - start) % CYCLE;
        var maxH = 0;
        if (t < 2200) {
          phase.textContent = 'SOMMATION PAR BIPS';
          levelWrap.classList.remove('hot');
          for (var i = 0; i < N; i++) {
            var h = 5 + Math.random() * 7 * mult[i];
            bars[i].style.height = h + '%';
            colore(bars[i], h);
            peakVals[i] = 0;
          }
          level.textContent = '86';
        } else if (t < 6800) {
          phase.textContent = 'SATURATION 2–5 kHz';
          levelWrap.classList.add('hot');
          var strong = (Date.now() - lastHit) > 500 && Math.random() < .55;
          if (strong) lastHit = Date.now();
          for (var i = 0; i < N; i++) {
            var base = 52 * mult[i];
            var h = strong ? Math.min(97, (72 + Math.random() * 23) * mult[i]) : base + Math.random() * 12;
            if (strong) { bars[i].classList.add('jump'); }
            bars[i].style.height = h + '%';
            colore(bars[i], h);
            if (strong) { void bars[i].offsetHeight; bars[i].classList.remove('jump'); }
            if (h > peakVals[i]) peakVals[i] = h;
            if (h > maxH) maxH = h;
          }
          if (strong) {
            level.textContent = toDb(Math.max(77, maxH));
          }
        } else {
          phase.textContent = 'ARRÊT AUTOMATIQUE · 180 s MAX';
          levelWrap.classList.remove('hot');
          for (var i = 0; i < N; i++) {
            bars[i].style.height = '3%';
            colore(bars[i], 3);
            peakVals[i] = Math.max(0, peakVals[i] - 6);
          }
          level.textContent = '0';
        }
      }, 260);
    });

    /* == 8. Frise historique : une succession d'images == */
    phByText('Frise historique').forEach(function(el){
      widgetize(el).classList.add('frise-w','frise-img');
      var steps = [
        ['' + window.LS_A + 'frise__locator-1940.jpg', 'Années 1940', 'Premières études acoustiques', ''],
        ['DARPA', 'Années 1960-80', 'Recherches DARPA', ''],
        ['' + window.LS_A + 'frise__lrad-2003.jpg', '2003', 'Le LRAD en opération', ''],
        ['' + window.LS_A + 'frise__proto-2025.jpg', '2025', 'Prototypes, Strasbourg', ''],
        ['' + window.LS_A + 'gallery__g1.jpg', '2026', 'LIMA SHIELD', 'now']
      ];
      var html = '<div class="fw2">';
      steps.forEach(function(s){
        var img;
        if (s[0] === 'DARPA') img = '<div class="fw2-img fw2-logos"><img src="' + window.LS_A + 'frise__darpa-big.png" alt="DARPA"></div>';
        else if (s[0] === 'VIDE') img = '<div class="fw2-img fw2-vide"></div>';
        else img = '<div class="fw2-img"><img src="' + s[0] + '" alt=""></div>';
        html += '<div class="fw2-c' + (s[3] ? ' now' : '') + '">' + img + '<b>' + s[1] + '</b><span>' + s[2] + '</span></div>';
      });
      el.innerHTML = html + '</div>';
    });

    /* == 9. Schéma des capteurs : grille thermique 192 points + pill RGPD == */
    phByText('Schéma des capteurs').forEach(function(el){
      widgetize(el).classList.add('thermal-w');
      var HUMAN = ["0000000000000000","0000002220000000","0000023332000000","0000023432000000",
                 "0000123433210000","0001233333321000","0000023332000000","0000022322000000",
                 "0000022022000000","0000022022000000","0000011011000000","0000000000000000"];
      var CAT = ["0000000000000000","0000000000000000","0000000000000000","0000000000000000",
                 "0000000000000000","0000000000000000","0000000000000000","0000110000000000",
                 "0001221000011000","0012222111121000","0011222222210000","0000110011000000"];
      function gridHtml(map){
        var h = '<div class="tw-grid">';
        map.forEach(function(row){ row.split('').forEach(function(ch){ h += '<i data-base="' + ch + '" class="' + (ch !== '0' ? 'g' + ch : '') + '"></i>'; }); });
        return h + '</div>';
      }
      var html = '<div class="tw-pill"><span class="tw-roundel">RGPD<br>CNIL</span><div><b>Aucune image, aucune donnée biométrique</b><span>Conforme au RGPD et aux recommandations de la CNIL.</span></div></div>';
      html += '<div class="tw-head">CE QUE LE SHIELD PERÇOIT</div>';
      html += '<div class="tw-duo">';
      html += '<div class="tw-col">' + gridHtml(HUMAN) + '<div class="tw-cap">Une silhouette humaine : sommation, puis dissuasion.</div></div>';
      html += '<div class="tw-col">' + gridHtml(CAT) + '<div class="tw-cap">Un chat : petit gabarit, ignoré. Aucun déclenchement.</div></div>';
      html += '</div><div class="tw-cap tw-cap-main">192 points de chaleur. Pas une photo.</div>';
      el.innerHTML = html;
      var cells = el.querySelectorAll('.tw-grid i');
      setInterval(function(){
        Array.prototype.forEach.call(cells, function(c){
          var base = parseInt(c.getAttribute('data-base'), 10);
          if (!base) return;
          var lvl = base;
          if (Math.random() < .25) lvl = Math.max(1, Math.min(4, base + (Math.random() < .5 ? -1 : 1)));
          c.className = 'g' + lvl;
        });
      }, 480);
    });

    /* == 10. Graphique 2 axes : matrice dissuasion / intégrité physique == */
    phByText('Graphique 2 axes').forEach(function(el){
      widgetize(el).classList.add('matrix-w');
      /* les concurrents s'alignent sur une frontière concave implicite ; LIMA seul au-dessus */
      /* Chaque solution est un point. Arme à feu et arme blanche sont distinctes.
         Liste ouverte : on l'enrichit en ajoutant une ligne, x et y en pourcentage
         (x : préservation de l'intégrité physique, y : dissuasion, 0 en haut). */
      var dots = [
        ['red', 6, 6, 'Arme à feu', 'Dissuade, blesse ou tue · risque légal majeur', ''],
        ['red', 12, 26, 'Arme blanche', 'Dissuade au contact, blesse · risque légal majeur', ''],
        ['red', 20, 46, 'Chien de défense', 'Imprévisible, morsures · risque légal majeur', ''],
        ['orange', 38, 60, 'Stroboscope', 'Désoriente, chutes possibles', ''],
        ['orange', 56, 76, 'Brouillard opacifiant', 'Aveugle, chutes possibles', 'flip'],
        ['grey', 76, 88, 'Alarme', 'Prévient, ne fait pas fuir', 'flip'],
        ['grey', 93, 94, 'Caméras', 'Enregistrent, ne font pas fuir', 'flip'],
        ['hero', 90, 12, 'LIMA SHIELD', 'Fuite réflexe, sans séquelle durable', '']
      ];
      var html = '<div class="mx-frame"><div class="mx-area">';
      dots.forEach(function(d){
        html += '<div class="mx-dot ' + d[0] + (d[5] ? ' ' + d[5] : '') + '" style="left:' + d[1] + '%;top:' + d[2] + '%"><i></i><div class="mx-lbl"><b>' + d[3] + '</b><span>' + d[4] + '</span></div></div>';
      });
      html += '</div><span class="mx-y">DISSUASION</span><span class="mx-yh">Fuite immédiate</span><span class="mx-yl">Aucune</span>';
      html += '<span class="mx-x">PRÉSERVATION DE L\'INTÉGRITÉ PHYSIQUE</span><span class="mx-xl">Blessures probables</span><span class="mx-xh">Sans séquelle durable</span></div>';
      html += '<div class="mx-legend"><span><i style="background:#e05252"></i>Risque de blessure</span><span><i style="background:#e85a00"></i>Risque modéré</span><span><i style="background:#8a8f8c"></i>Sans blessure, peu dissuasif</span></div>';
      el.innerHTML = html;
    });

    /* == 11. Icônes des tuiles environnements == */
    var icons = {
      'Habitat': 'M3 11.5 12 4l9 7.5 M5.5 10.5V20h13v-9.5',
      'Commerces': 'M4 9l1.2-4h13.6L20 9 M4 9v11h16V9 M4 9h16 M9.5 20v-6h5v6',
      'Espaces publics': 'M12 3 3 8.5h18L12 3Z M5 10.5V18 M9.7 10.5V18 M14.3 10.5V18 M19 10.5V18 M3 20.5h18',
      'Zones logistiques': 'M12 3 4 7v10l8 4 8-4V7l-8-4Z M4 7l8 4 8-4 M12 11v10',
      'Chantiers': 'M10.2 4h3.6L18 18H6L10.2 4Z M8.6 12h6.8 M4 20.5h16',
      'Véhicules': 'M5 15.5 6.7 10h10.6L19 15.5 M3.5 15.5h17V19h-17v-3.5 M7 19a1.6 1.6 0 1 0 3.2 0 M13.8 19a1.6 1.6 0 1 0 3.2 0',
      'Alerte garantie': 'M6 9a6 6 0 0 1 12 0c0 5 2 6 2 6H4s2-1 2-6 M10.3 19a2 2 0 0 0 3.4 0',
      '4G de secours': 'M2 20h.01 M7 20v-4 M12 20v-8 M17 20V8 M22 20V4',
      'Résistant au brouillage': 'M12 3l7 3v5c0 5-3.5 8.5-7 10-3.5-1.5-7-5-7-10V6z M8.5 11.5a5 5 0 0 1 7 0 M10.4 13.6a2.4 2.4 0 0 1 3.2 0',
      "1 mois d'autonomie": 'M3 8h13a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-4a2 2 0 0 1 2-2Z M21 11v2 M5 10.5v3 M8.5 10.5v3',
      'Communications chiffrées': 'M4 11h16v9H4z M8 11V7a4 4 0 0 1 8 0v4',
      'Auto-protection': 'M12 3l7 3v5c0 5-3.5 8.5-7 10-3.5-1.5-7-5-7-10V6z M12 8v4 M12 15h.01'
    };
    Array.prototype.forEach.call(document.querySelectorAll('.grid6 div'), function(tile){
      var st = tile.querySelector('strong');
      if (!st) return;
      var key = Object.keys(icons).filter(function(k){ return st.textContent.indexOf(k) === 0; })[0];
      if (!key) return;
      var svg = document.createElementNS('http://www.w3.org/2000/svg','svg');
      svg.setAttribute('viewBox','0 0 24 24');
      svg.setAttribute('class','env-ico');
      svg.innerHTML = '<path d="' + icons[key] + '" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>';
      tile.insertBefore(svg, tile.firstChild);
    });

    /* == 12. RÈGLE B : le système de citations, classé par la SOURCE et non par la classe ==
       Source = une personne de Lima (Cédric Fontaine, ingénieur) -> carte d'expert, guillemet anglo-saxon.
       Source = un média ou une institution -> la citation fait partie du texte : italique, (source). */
    function sourceEstExpert(txt){
      return /Cédric\s+Fontaine|fondateur de Lima|ingénieur|Républik Group/i.test(txt);
    }
    function nettoieGuillemets(html){
      return html.replace(/«\s*/g, '').replace(/\s*»/g, '');
    }
    Array.prototype.forEach.call(document.querySelectorAll('.quote-top, .exergue'), function(q){
      if (q.getAttribute('data-quote-done')) return;
      q.setAttribute('data-quote-done', '1');
      var src = q.querySelector('.muted, .who');
      var srcTxt = src ? src.textContent.trim() : '';
      if (src) src.remove();
      var corps = nettoieGuillemets(q.innerHTML).trim();

      if (srcTxt && sourceEstExpert(srcTxt)) {
        /* carte d'expert */
        q.className = 'exergue';
        q.innerHTML = corps + '<span class="who">' + srcTxt.replace(/\s*\[[^\]]*\]/g, '') + '</span>';
      } else {
        /* citation de presse ou d'institution : dans le texte */
        q.className = 'quote-top press-q';
        var tail = srcTxt ? ' <span class="muted press-src press-inline">(' + srcTxt.replace(/^[(]|[)]$/g, '') + ')</span>' : '';
        q.innerHTML = corps.replace(/[\s\u00a0]+$/, '') + tail;
      }
    });

    /* == 12a-bis. Essai Maurice 2026-09-01 : deux sections passent en sombre == */
    Array.prototype.forEach.call(document.querySelectorAll('h2'), function(h){
      var txt = h.textContent;
      if (txt.indexOf('Il ne filme rien') !== -1 || txt.indexOf('Dissuader sans blesser') !== -1) {
        var sec = h.closest('section');
        if (sec) { sec.classList.add('dark'); sec.removeAttribute('style'); }
      }
    });

    /* == 12b. Les notes de travail entre crochets ne s'affichent jamais == */
    Array.prototype.forEach.call(document.querySelectorAll('p'), function(par){
      var txt = par.textContent.trim();
      if (txt.indexOf('Badges officiels') !== -1) return;
      if (txt.length > 2 && txt.charAt(0) === '[' && txt.charAt(txt.length - 1) === ']' && txt.indexOf('Lorem') === -1 && txt.indexOf('Témoignage') === -1) {
        par.style.display = 'none';
      }
    });
    Array.prototype.forEach.call(document.querySelectorAll('.who, .exergue .who'), function(w){
      w.innerHTML = w.innerHTML.replace(/\s*\[[^\]]*\]/g, '').replace(/^[\s,]+/, '');
    });

    /* F35 : le bloc d'autorité est normalisé partout, une fois toutes les cellules identifiées */
    var mursVus = [];
    Array.prototype.forEach.call(document.querySelectorAll('.media-cell'), function(c){
      var par = c.parentNode;
      if (par && mursVus.indexOf(par) === -1) mursVus.push(par);
    });
    mursVus.forEach(function(mur){
      /* la page porte déjà la ligne en haut : ce second bloc est un doublon */
      if (document.documentElement.getAttribute('data-ligne-medias') === '1') {
        var sg = mur.closest('section');
        if (sg && sg.parentNode) sg.parentNode.removeChild(sg); else mur.parentNode.removeChild(mur);
        return;
      }
      mur.classList.add('media-wall');
      /* le bloc d'autorité ne se pose JAMAIS sans son titre. On regarde ce qui précède
         immédiatement le bloc : un titre plus haut dans la section sert à un autre bloc. */
      var avant = mur.previousElementSibling;
      var aTitre = avant && /^H[1-4]$/.test(avant.tagName);
      if (!aTitre) {
        var t = document.createElement('h2');
        t.className = 'titre-injecte';
        t.textContent = 'Ils parlent de nous.';
        mur.parentNode.insertBefore(t, mur);
        var inner = mur.closest('.inner');
        if (inner) inner.classList.add('center');
      }
      mur.removeAttribute('style');
    });

    /* == 13. Badges vie privée : médaillons circulaires (réf. maquette funnel) == */
    var medals = {
      'Conforme RGPD': ['RGPD', 'CONFORME RGPD · CNIL · ', 'green'],
      'Zéro caméra': ['ZÉRO', 'ZÉRO CAMÉRA · AUCUNE IMAGE · ', 'green'],
      'Normes CE': ['CE', 'NORMES CE · RED · EMC · LVD · ROHS · ', ''],
      'Données chiffrées': ['CHIFFRÉ', 'DONNÉES CHIFFRÉES · OTA SÉCURISÉ · ', ''],
      'Audité en cybersécurité': ['AUDIT', 'AUDITÉ EN CYBERSÉCURITÉ · ', '']
    };
    var mcount = 0;
    var medalEls = [];
    Array.prototype.forEach.call(document.querySelectorAll('.badge'), function(b){
      var m = medals[b.textContent.trim()];
      if (!m) return;
      medalEls.push(b);
      if (isP2) {
        var label = b.textContent.trim();
        var icons = {
          'Conforme RGPD': '<path d="M12 3l7 3v5c0 5-3.5 8.5-7 10-3.5-1.5-7-5-7-10V6z"/><path d="M9 12l2 2 4-4"/>',
          'Zéro caméra': '<path d="M16 16H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h1"/><path d="M10 6h4a2 2 0 0 1 2 2v2l5-3v10"/><path d="M3 3l18 18"/>',
          'Normes CE': '<circle cx="12" cy="12" r="9"/><path d="M15 9.5A4.2 4.2 0 0 0 12 8a4 4 0 0 0 0 8 4.2 4.2 0 0 0 3-1.5"/>',
          'Données chiffrées': '<rect x="4" y="11" width="16" height="9" rx="2"/><path d="M8 11V7a4 4 0 0 1 8 0v4"/>',
          'Audité en cybersécurité': '<circle cx="11" cy="11" r="7"/><path d="M21 21l-4.3-4.3"/><path d="M8.5 11l1.8 1.8L14 9.2"/>'
        };
        b.classList.add('p2badge');
        b.innerHTML = '<i><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round">' + (icons[label] || '<path d="M5 12l4 4 10-10"/>') + '</svg></i>' + label;
        return;
      }
      mcount++;
      var id = 'medc' + mcount;
      var col = m[2] === 'green' ? '#8fb07f' : '#a8b1ab';
      var ringOp = m[2] === 'green' ? '.5' : '.25';
      b.classList.add('medal');
      b.innerHTML =
        '<svg viewBox="0 0 130 130">' +
        '<defs><path id="' + id + '" d="M 65,65 m -52,0 a 52,52 0 1,1 104,0 a 52,52 0 1,1 -104,0"/></defs>' +
        '<circle cx="65" cy="65" r="63" fill="none" stroke="' + col + '" stroke-opacity="' + ringOp + '" stroke-width="1"/>' +
        '<circle cx="65" cy="65" r="40" fill="rgba(255,255,255,.03)" stroke="' + col + '" stroke-opacity=".55" stroke-width="1"/>' +
        '<g class="ring-text"><text fill="' + col + '" font-family="IBM Plex Mono,monospace" font-size="9.5" letter-spacing="2.5"><textPath href="#' + id + '">' + m[1] + m[1] + '</textPath></text></g>' +
        '<text x="65" y="70" text-anchor="middle" fill="#f2f5f2" font-size="' + (m[0].length > 4 ? 12 : 19) + '" font-family="Poppins,sans-serif" font-weight="500">' + m[0] + '</text>' +
        '</svg>';
    });
    if (medalEls.length) {
      var row = document.createElement('div');
      row.className = 'medal-row';
      medalEls[0].parentNode.insertBefore(row, medalEls[0]);
      if (isP2 && medalEls.length === 5) {
        var l1 = document.createElement('div'); l1.className = 'medal-line';
        var l2 = document.createElement('div'); l2.className = 'medal-line';
        medalEls.slice(0,3).forEach(function(b){ l1.appendChild(b); });
        medalEls.slice(3).forEach(function(b){ l2.appendChild(b); });
        row.appendChild(l1); row.appendChild(l2);
      } else {
        medalEls.forEach(function(b){ row.appendChild(b); });
      }
    }

    /* == 14. Vidéo produit : l'embed Wistia du site officiel == */
    phByText('Vidéo produit').forEach(function(el){
      widgetize(el).classList.add('video-w');
      el.innerHTML = '<iframe src="https://fast.wistia.net/embed/iframe/1ua9b128lz" allow="autoplay; fullscreen" allowfullscreen frameborder="0" scrolling="no" title="LIMA SHIELD"></iframe>';
    });

    /* == 15. Badges des garanties : médaillons == */
    Array.prototype.forEach.call(document.querySelectorAll('.garantie'), function(g){
      var ph = g.querySelector('.ph');
      var num = g.querySelector('.num');
      if (!ph || !num) return;
      var is30 = num.textContent.indexOf('30') !== -1;
      if (isP2) {
        ph.classList.add('g-chip-wrap');
        ph.style.cssText = 'height:72px;width:72px;border:none;background:transparent;padding:0;box-shadow:none;';
        var ico30 = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"><path d="M3 12a9 9 0 1 0 2.6-6.4L3 8"/><path d="M3 3v5h5"/><path d="M12 8v4l2.8 1.7"/></svg>';
        var ico5 = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"><path d="M12 3l7 3v5c0 5-3.5 8.5-7 10-3.5-1.5-7-5-7-10V6z"/><path d="M9 12l2 2 4.5-4.5"/></svg>';
        ph.innerHTML = '<span class="g-badge' + (is30 ? ' ok' : ' brand') + '">' + (is30 ? ico30 : ico5) + '</span>';
        return;
      }
      var id = is30 ? 'medg30' : 'medg5';
      var col = is30 ? '#8fb07f' : '#e85a00';
      var ring = is30 ? 'GARANTIE COMMERCIALE · 30 JOURS · GARANTIE COMMERCIALE · 30 JOURS · ' : 'GARANTIE TECHNIQUE · 2 ANS · GARANTIE TECHNIQUE · 2 ANS · ';
      var center = is30 ? '30 J' : '2 ANS';
      ph.classList.add('medal-g');
      ph.textContent = '';
      ph.style.cssText = 'height:118px;width:118px;border:none;background:transparent;padding:0;';
      ph.innerHTML = '<svg viewBox="0 0 130 130" style="width:118px;height:118px;display:block">' +
        '<defs><path id="' + id + '" d="M 65,65 m -52,0 a 52,52 0 1,1 104,0 a 52,52 0 1,1 -104,0"/></defs>' +
        '<circle cx="65" cy="65" r="63" fill="none" stroke="' + col + '" stroke-opacity=".4" stroke-width="1"/>' +
        '<circle cx="65" cy="65" r="40" fill="rgba(255,255,255,.03)" stroke="' + col + '" stroke-opacity=".55" stroke-width="1"/>' +
        '<g class="ring-text"><text fill="' + col + '" font-family="IBM Plex Mono,monospace" font-size="9.5" letter-spacing="2.5"><textPath href="#' + id + '">' + ring + '</textPath></text></g>' +
        '<text x="65" y="71" text-anchor="middle" fill="#f2f5f2" font-size="17" font-family="Poppins,sans-serif" font-weight="500">' + center + '</text>' +
        '</svg>';
    });

    /* == 16. Mockup application : trois écrans au kit PROJET 2 (lumineux cartes smart home) == */
    /* on reconnaît l'emplacement au SENS (mockup / illustrations / écrans de l'application),
       pas à une formulation exacte : le fond ne l'écrit pas pareil d'une page à l'autre. */
    var placesMockup = all.filter(function(el){
      var t = el.textContent;
      return /application/i.test(t) && /Mockup|Illustration|écrans?\b/i.test(t);
    });
    [1].forEach(function(){ placesMockup.forEach(function(el){
      if (el.classList.contains('widgetized')) return;
      var f = document.createElement('link');
      f.rel = 'stylesheet';
      f.href = 'https://fonts.googleapis.com/css2?family=Outfit:wght@400;500;600;700&display=swap';
      document.head.appendChild(f);
      widgetize(el).classList.add('appmock-w');
      /* Les écrans sont les VRAIES captures de l'application (Maurice, 2026-10-12) :
         à gauche et à droite l'accueil avec le Shield (armé / désarmé), au milieu le
         réglage de la puissance sonore. Les écrans dessinés en code sont abandonnés. */
      var screens = [
        {tilt:'rotateY(14deg) rotateX(3deg) scale(.92)', src:'' + window.LS_A + 'app__ecran-arme.jpg', alt:'Application Lima Shield Connect : système armé'},
        {tilt:'rotateX(2deg)', src:'' + window.LS_A + 'app__ecran-puissance.jpg', alt:'Application Lima Shield Connect : réglage de la puissance de la sirène, de 86 à 138 dB'},
        {tilt:'rotateY(-14deg) rotateX(3deg) scale(.92)', src:'' + window.LS_A + 'app__ecran-desarme.jpg', alt:'Application Lima Shield Connect : système désarmé'}
      ];
      var html = '<div class="pm-stage">';
      screens.forEach(function(s){
        html += '<div class="pm-phone" style="transform:' + s.tilt + '"><div class="pm-notch"></div><div class="pm-screen shot"><img src="' + s.src + '" alt="' + s.alt + '" loading="lazy"></div></div>';
      });
      html += '</div><div class="store-badges">' + badgesStores() + '</div>';
      el.innerHTML = html;
    }); });

    /* == 17. Badges officiels des stores dans le footer == */
    /* les badges mènent aux fiches de l'application Lima Shield Connect (Maurice, 2026-10-15) */
    function badgesStores(){
      return '<a href="https://apps.apple.com/fr/app/lima-shield-connect/id6756607371" target="_blank" rel="noopener"><img src="' + window.LS_A + 'logos__badge-appstore.svg" alt="Télécharger dans l\u2019App Store"></a>' +
        '<a href="https://play.google.com/store/apps/details?id=com.limashield" target="_blank" rel="noopener"><img src="' + window.LS_A + 'logos__badge-googleplay.svg" alt="Disponible sur Google Play"></a>';
    }
    var badgesPoses = document.querySelectorAll('.store-badges').length;
    Array.prototype.forEach.call(document.querySelectorAll('footer p, section p, .inner p, .ph'), function(par){
      if (par.textContent.indexOf('Badges officiels') === -1) return;
      if (par.querySelector('img')) return;
      /* une seule paire de badges dans le corps de la page ; le pied de page a la sienne */
      var dansFooter = !!par.closest('footer');
      if (!dansFooter) {
        if (badgesPoses >= 1) { par.remove(); return; }
        badgesPoses++;
      }
      par.classList.add('store-badges');
      par.innerHTML = badgesStores();
    });

    /* Emplacements de badges explicites : <p class="store-badges" data-badges></p> reçoit la paire,
       là où le guide en a besoin (en tête, puis à l'étape de téléchargement). */
    Array.prototype.forEach.call(document.querySelectorAll('.store-badges[data-badges]'), function(p){
      if (!p.querySelector('img')) p.innerHTML = badgesStores();
    });

    /* == 17a. Icônes des CTA (Projet 2) : flèche pour acheter, WhatsApp pour la démo == */
    if (isP2) {
      var arrow = '<svg class="cta-ico" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M4 12h15"/><path d="M12 5l7 7-7 7"/></svg>';
      var wa = '<svg class="cta-ico" viewBox="0 0 24 24" fill="currentColor"><path d="M12.04 2C6.58 2 2.13 6.45 2.13 11.91c0 1.75.46 3.45 1.32 4.95L2.05 22l5.25-1.38a9.87 9.87 0 0 0 4.74 1.21h.01c5.46 0 9.9-4.45 9.9-9.91 0-2.65-1.03-5.14-2.9-7.01A9.82 9.82 0 0 0 12.04 2zm0 18.15h-.01a8.2 8.2 0 0 1-4.18-1.15l-.3-.18-3.12.82.83-3.04-.2-.31a8.2 8.2 0 0 1-1.26-4.38c0-4.54 3.7-8.24 8.25-8.24 2.2 0 4.27.86 5.82 2.42a8.18 8.18 0 0 1 2.41 5.83c0 4.54-3.7 8.23-8.24 8.23zm4.52-6.16c-.25-.13-1.47-.72-1.69-.81-.23-.08-.39-.12-.56.13-.17.24-.64.8-.78.97-.14.16-.29.18-.54.06-.25-.13-1.05-.39-2-1.23-.74-.66-1.23-1.47-1.38-1.72-.14-.25-.02-.38.11-.51.11-.11.25-.29.37-.43.12-.14.16-.25.25-.41.08-.17.04-.31-.02-.43-.06-.13-.56-1.34-.76-1.84-.2-.48-.41-.42-.56-.43h-.48c-.17 0-.43.06-.66.31-.22.25-.86.85-.86 2.07 0 1.22.89 2.4 1.01 2.56.12.17 1.75 2.67 4.23 3.74.59.26 1.05.41 1.41.52.59.19 1.13.16 1.56.1.48-.07 1.47-.6 1.67-1.18.21-.58.21-1.07.15-1.18-.06-.1-.23-.16-.48-.29z"/></svg>';
      Array.prototype.forEach.call(document.querySelectorAll('.cta'), function(b){
        var target = b.querySelector('small') || null;
        var span = document.createElement('span');
        span.className = 'cta-ico-wrap';
        span.innerHTML = b.classList.contains('secondary') ? wa : arrow;
        b.insertBefore(span, b.firstChild);
      });
    }

    /* == 18. Micro-effet Projet 2 : entrée 400 ms / +12 px au scroll == */
    if (isP2 && 'IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      var targets = document.querySelectorAll('.ph.widgetized, .ph.swap-media, .kpis div, .grid6 div, .card, .encart, .exergue, .garantie, .pricebox, .kl, .p2badge');
      var io = new IntersectionObserver(function(entries){
        entries.forEach(function(e){
          if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
        });
      }, {threshold: 0.12});
      Array.prototype.forEach.call(targets, function(el){
        el.classList.add('rv');
        io.observe(el);
      });
    }

    /* == 20. PAGES SECONDAIRES : le design-system couvre leurs placeholders == */

    /* 20a. Toutes les photos produit : les vraies photos, en rotation */
    var gal = ['g1','g2','g4','g3','g5'];
    var gi = 0;
    /* règle A6 : chaque page présente le produit par la galerie, pas par une photo isolée */
    if (!estComprendre && !estComparatif && !document.querySelector('.pgal')) {
      var premiere = phByText('Photo du produit')[0];
      if (premiere) buildGallery(premiere);
    }
    /* F-images : on ne jette pas d'images, on n'en intercale pas pour rien.
       La première présentation du produit est la galerie (déjà posée). Aucune autre
       photo produit n'est intercalée dans le fil : les emplacements suivants sont retirés.
       Les photos DANS une carte de preuve restent (c'est le portrait du client). */
    var photosPosees = 1;
    if (estComparatif) {
      var places = phByText('Photo du produit');
      var choisie = null;
      Array.prototype.forEach.call(document.querySelectorAll('h2'), function(h){
        if (choisie) return;
        if (!/c.est quoi|en deux mots|dispositif derrière|le dispositif/i.test(h.textContent)) return;
        var sec = h.closest('section');
        if (!sec) return;
        for (var i = 0; i < places.length; i++) { if (sec.contains(places[i])) { choisie = places[i]; break; } }
      });
      if (!choisie && places.length) choisie = places[places.length - 1];
      places.forEach(function(el){
        if (el === choisie) fillImg(el, '' + window.LS_A + 'gallery__g1.jpg', '50% 50%', '360px');
        else el.remove();
      });
    }
    ['Photo du produit', 'Photo de Stéphane', 'Photo de Philippe', 'Photo ou avatar de Yoann',
     'Photo : boutique', 'Photo : bureau de tabac', 'Photo : bâtiment municipal',
     'Photo du bouton panique', 'Photo du clavier', 'Photo du produit avec'].forEach(function(key){
      phByText(key).forEach(function(el){
        if (el.classList.contains('swap-media') || el.classList.contains('widgetized')) return;
        var inCard = el.closest && el.closest('.card');
        if (inCard) { fillImg(el, '' + window.LS_A + 'proof-placeholder.jpg', '50% 50%', '170px'); return; }
        if (photosPosees >= 1) { el.remove(); return; }
        photosPosees++;
        fillImg(el, '' + window.LS_A + 'gallery__' + gal[gi % gal.length] + '.jpg', '50% 50%', '260px');
        gi++;
      });
    });

    /* 20b. Étoiles */
    phByText('★★★★★').forEach(function(el){
      if (el.classList.contains('widgetized')) return;
      widgetize(el).classList.add('stars-w');
      el.innerHTML = '<div class="fstars"><i>★</i><i>★</i><i>★</i><i>★</i><i>★</i></div>';
    });

    /* 20b-bis. Étoiles écrites en clair dans une carte : le composant */
    var starMark = '[ ★★★★★ ]';
    Array.prototype.forEach.call(document.querySelectorAll('div, p, span, li'), function(el){
      if (el.children.length > 6) return;
      if (el.innerHTML.indexOf(starMark) === -1) return;
      el.innerHTML = el.innerHTML.split(starMark).join('<span class="fstars inline"><i>★</i><i>★</i><i>★</i><i>★</i><i>★</i></span>');
    });

    /* 20b-quater. RÈGLE A13 : revue de presse, le logo du média au bas de chaque encadré */
    var presseLogos = [
      ['Le Figaro', 'media-figaro-blue.png'], ['CNEWS', 'med-cnews.svg'], ['CNews', 'med-cnews.svg'],
      ['franceinfo', 'med-franceinfo.svg'], ['France Bleu', 'med-francebleu.svg'],
      ['Europe 1', 'med-europe1.svg'], ['France 24', 'med-france24.svg'],
      ['Le Moniteur', 'med-moniteur.svg'], ["Ministère de l'Intérieur", 'src-interieur.svg'],
      ['Sénat', 'src-senat-1.png'], ['Fédération Française du Bâtiment', 'src-ffb-0.png'],
      ['Républik Group', 'media-republik-color.jpg'], ['NRJ', 'media-nrj.png'],
      ['France Cryptos', 'media-francecryptos-dark.png'],
      ['Maire-Info', 'med-maireinfo.png'], ['France 3 Occitanie', 'med-france3-occitanie.svg'],
      ['Construction BTP', 'med-constructionbtp.png'], ['Le Monde du Tabac', 'med-mondedutabac.jpg']
    ];
    function logoPourSource(txt){
      for (var i = 0; i < presseLogos.length; i++) {
        if (txt.indexOf(presseLogos[i][0]) !== -1) return presseLogos[i][1];
      }
      return null;
    }
    Array.prototype.forEach.call(document.querySelectorAll('.card2, .card, .cards2 > div, .choose > div, .grid6 > div'), function(card){
      if (card.getAttribute('data-presse-done')) return;
      var src = card.querySelector('.muted');
      if (!src) return;
      var f = logoPourSource(src.textContent);
      if (!f) return;
      card.setAttribute('data-presse-done', '1');
      card.classList.add('pr-card');
      var wrap = document.createElement('div');
      wrap.className = 'pr-logo';
      wrap.innerHTML = '<img src="' + window.LS_A + 'logos__' + f + '" alt="">';
      card.appendChild(wrap);
    });

    /* 20b-pre. NORMALISATION DU VOCABULAIRE : le fond livre des blocs sans classe, avec des
       styles écrits en dur. On les traduit vers les deux composants du système, sinon la même
       chose se dessine de deux façons selon la page (défaut relevé par Maurice le 2026-09-01).
         - tuile de SPÉCIFICATION : une donnée courte, pas de titre  -> .spec-tile
         - carte de CONTENU       : un titre en gras et une phrase   -> .sys-tile */
    Array.prototype.forEach.call(document.querySelectorAll('div[style*="border:1px solid #ddd"], div[style*="border: 1px solid #ddd"]'), function(d){
      var court = d.textContent.trim().length <= 70;
      var titre = d.querySelector('strong, b, h3, h4, li, p');
      d.classList.add(court && !titre ? 'spec-tile' : 'sys-tile');
      d.removeAttribute('style');
    });


    /* 20b-quinquies. RÈGLE A1 : les tuiles de caractéristiques reçoivent leur icône */
    var specIcons = [
      [/\bdB\b|décibel/i, 'M11 5 6 9H3v6h3l5 4V5z M15.5 9.5a4 4 0 0 1 0 5 M18.5 7a7.5 7.5 0 0 1 0 10'],
      [/m²|surface|volume/i, 'M4 4h16v16H4z M4 9h16 M9 4v16'],
      [/autonomie|batterie/i, 'M3 8h13a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-4a2 2 0 0 1 2-2Z M21 11v2 M5 10.5v3 M8.5 10.5v3'],
      [/4G|réseau|wi-?fi|ethernet|connect/i, 'M2 20h.01 M7 20v-4 M12 20v-8 M17 20V8 M22 20V4'],
      [/alarme|compatible/i, 'M12 3l7 3v5c0 5-3.5 8.5-7 10-3.5-1.5-7-5-7-10V6z M9 12l2 2 4.5-4.5'],
      [/app mobile|application|iOS|Android/i, 'M7 2.5h10a2 2 0 0 1 2 2v15a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2v-15a2 2 0 0 1 2-2Z M10.5 18.5h3'],
      [/digicode|badge|clavier/i, 'M4 5h16v14H4z M8 9h.01 M12 9h.01 M16 9h.01 M8 13h.01 M12 13h.01 M16 13h.01 M9 17h6'],
      [/panique|télécommande/i, 'M12 3v6 M5.6 5.6l4.2 4.2 M3 12h6 M18.4 5.6l-4.2 4.2 M21 12h-6 M12 15a3 3 0 1 0 0 6 3 3 0 0 0 0-6z'],
      [/caméra|image|RGPD/i, 'M16 16H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h1 M10 6h4a2 2 0 0 1 2 2v2l5-3v10 M3 3l18 18'],
      [/garantie|2 ans/i, 'M12 3l7 3v5c0 5-3.5 8.5-7 10-3.5-1.5-7-5-7-10V6z M9 12l2 2 4.5-4.5'],
      [/poids|kg|cm|dimension/i, 'M3 7h18l-2 13H5L3 7Z M8 7V5a4 4 0 0 1 8 0v2'],
      [/IP54|poussière|humidité/i, 'M12 3s6 6.5 6 10.5A6 6 0 0 1 6 13.5C6 9.5 12 3 12 3z'],
      [/kHz|\bHz\b|fréquence|bande/i, 'M2 12h3l2.5-7 3.5 14 3-10 2 3h6'],
      [/détection|portée|mètres|infrarouge|thermique|capteur/i, 'M12 9a3 3 0 1 0 0 6 3 3 0 0 0 0-6z M5.6 5.6a9 9 0 0 0 0 12.8 M18.4 18.4a9 9 0 0 0 0-12.8']
    ];
    /* F26 : dans une série, TOUS les éléments ont une icône. Ce qu'aucun motif ne couvre
       reçoit l'icône neutre, jamais rien. */
    var icoNeutre = 'M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18z M12 8h.01 M11.25 12h1v4.5h1';
    /* LE WIDGET DU DESIGN SYSTEM : pastille ronde à gauche, libellé en gras, valeur en gris.
       Une tuile de spécification est ce widget, comme toutes les autres tuiles du site.
       Le libellé est une catégorie déduite du contenu, jamais une information ajoutée. */
    var specLabels = [
      [/\bdB\b|décibel/i, 'Puissance'],
      [/kHz|\bHz\b|fréquence|bande/i, 'Fréquence'],
      [/m²|surface|couvert/i, 'Couverture'],
      [/autonomie|batterie/i, 'Autonomie'],
      [/détection|portée|mètres|infrarouge|thermique|capteur/i, 'Détection'],
      [/4G|wi-?fi|ethernet|zigbee|réseau|box|connect/i, 'Connectivité'],
      [/IP54|poussière|humidité/i, 'Résistance'],
      [/garantie/i, 'Garantie'],
      [/\bkg\b|poids/i, 'Poids'],
      [/\bcm\b|dimension/i, 'Dimensions'],
      [/panique|télécommande/i, 'Commande'],
      [/digicode|badge|clavier/i, 'Accès'],
      [/caméra|image|RGPD/i, 'Vie privée'],
      [/app\b|iOS|Android|mobile|application/i, 'Application'],
      [/alarme|compatible/i, 'Compatibilité']
    ];
    Array.prototype.forEach.call(document.querySelectorAll('.kpis div, .chips div, .spec, .spec-tile'), function(tile){
      if (tile.children.length > 1 || tile.textContent.length > 70) return;
      if (tile.getAttribute('data-ico')) return;
      var txt = tile.textContent.trim();
      if (!txt) return;
      var d = null, libelle = null;
      for (var i = 0; i < specIcons.length; i++) { if (specIcons[i][0].test(txt)) { d = specIcons[i][1]; break; } }
      for (var k = 0; k < specLabels.length; k++) { if (specLabels[k][0].test(txt)) { libelle = specLabels[k][1]; break; } }
      if (!d) d = icoNeutre;
      if (!libelle) libelle = 'Caractéristique';
      /* si la valeur commence par le libellé, on ne le répète pas */
      var valeur = txt.replace(new RegExp('^' + libelle + '\\s*:?\\s*', 'i'), '').trim();
      if (!valeur) valeur = txt;
      valeur = valeur.charAt(0).toUpperCase() + valeur.slice(1);
      tile.setAttribute('data-ico', '1');
      tile.innerHTML =
        '<span class="ic-chip"><svg viewBox="0 0 24 24" class="spec-ico"><path d="' + d + '" fill="none" ' +
        'stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg></span>' +
        '<p class="spec-txt"><b>' + libelle + '.</b> ' + valeur + '</p>';
    });
    /* les cartes de contenu du fond gardent leur propre passe d'icône */
    Array.prototype.forEach.call(document.querySelectorAll('.sys-tile'), function(tile){
      if (tile.querySelector('svg') || tile.getAttribute('data-ico')) return;
      if (tile.textContent.length > 70) return;
      var txt = tile.textContent;
      var d = null;
      for (var i = 0; i < specIcons.length; i++) { if (specIcons[i][0].test(txt)) { d = specIcons[i][1]; break; } }
      if (!d) d = icoNeutre;
      tile.setAttribute('data-ico', '1');
      var sp = document.createElement('span');
      sp.className = 'ic-chip';
      sp.innerHTML = '<svg viewBox="0 0 24 24" class="spec-ico"><path d="' + d + '" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>';
      tile.insertBefore(sp, tile.firstChild);
    });

    /* 20b-sexies. RÈGLE D : les temps de gravité passent en sombre, sur toutes les pages */
    var graves = /ne fera jamais|ne feront jamais|ne fait pas|n'est pas un jouet|n'est pas un gadget|disponibilité limitée|risque juridique|et pourtant|ce que votre|ce que vos|technologie militaire|dernier recours|ce qui se passe vraiment|vous êtes équipé|sans blesser/i;
    /* PDF point 8 : la section choc (les chiffres bruts) est sombre.
       PDF point 11 : la section qui présente le produit sur un comparatif aussi. */
    var chocs = /ce que disent les chiffres|en deux mots|le dispositif derrière|c.est quoi un LIMA SHIELD|et LIMA SHIELD, au fait|l.alarme sonne|et maintenant\s?\?|3h du matin/i;
    Array.prototype.forEach.call(document.querySelectorAll('section'), function(sec){
      if (sec.classList.contains('dark')) return;
      var h = sec.querySelector('h2');
      if (document.documentElement.getAttribute('data-sans-sombre') === '1') return;
      if (h && (graves.test(h.textContent) || chocs.test(h.textContent))) {
        sec.classList.add('dark');
        sec.removeAttribute('style');
      }
    });
    /* RYTHME : une page ne reste jamais claire plus de trois sections d'affilée. Au-delà,
       la suivante passe en sombre. Sans cela, une page de comparatif enchaîne 5 000 px de
       crème sans respiration (relevé par Maurice le 2026-09-01). Deux sections sombres ne
       se suivent jamais, et une section trop courte ne sert pas de respiration. */
    (function rythmeDesFonds(){
      var secs = Array.prototype.slice.call(document.querySelectorAll('section'));
      var clairesDeSuite = 0;
      /* PDF point 21 : deux sections sombres ne se suivent jamais. On éclaircit la
         seconde d'une série, quelle que soit son origine. */
      secs.forEach(function(sec, i){
        var prec = secs[i - 1];
        if (sec.classList.contains('dark') && prec && prec.classList.contains('dark')) {
          sec.classList.remove('dark');
        }
        if (sec.classList.contains('dark')) { clairesDeSuite = 0; return; }
        clairesDeSuite++;
        if (clairesDeSuite <= 3) return;
        var suivante = secs[i + 1];
        var assezHaute = sec.getBoundingClientRect().height > 420;
        var derniere = (i >= secs.length - 1);
        if (!assezHaute || derniere) return;
        if (suivante && suivante.classList.contains('dark')) return;
        sec.classList.add('dark');
        sec.removeAttribute('style');
        clairesDeSuite = 0;
      });
    })();

    /* 20b-septies. RÈGLE A7 : là où l'histoire acoustique est racontée sans image, la frise s'affiche */
    /* une page qui raconte déjà son histoire en frise verticale (.etape) n'a pas besoin
       d'une seconde frise à l'horizontale */
    if (!document.querySelector('.frise-w') && !document.querySelector('.etape')) {
      var cible = null;
      Array.prototype.forEach.call(document.querySelectorAll('section p'), function(par){
        if (cible) return;
        if (/DARPA|LRAD/.test(par.textContent)) cible = par;
      });
      if (cible) {
        var holder = document.createElement('div');
        holder.className = 'ph';
        holder.textContent = '[ Frise historique ]';
        cible.parentNode.insertBefore(holder, cible.nextSibling);
        all.push(holder);
        phByText('Frise historique').forEach(function(el){
          if (el !== holder) return;
          widgetize(el).classList.add('frise-w','frise-img');
          var steps = [
            ['' + window.LS_A + 'frise__locator-1940.jpg', 'Années 1940', 'Premières études acoustiques', ''],
            ['DARPA', 'Années 1960-80', 'Recherches DARPA', ''],
            ['' + window.LS_A + 'frise__lrad-2003.jpg', '2003', 'Le LRAD en opération', ''],
            ['' + window.LS_A + 'frise__proto-2025.jpg', '2025', 'Prototypes, Strasbourg', ''],
            ['' + window.LS_A + 'gallery__g1.jpg', '2026', 'LIMA SHIELD', 'now']
          ];
          var html = '<div class="fw2">';
          steps.forEach(function(s){
            var img = s[0] === 'DARPA'
              ? '<div class="fw2-img fw2-logos"><img src="' + window.LS_A + 'frise__darpa-big.png" alt="DARPA"></div>'
              : '<div class="fw2-img"><img src="' + s[0] + '" alt=""></div>';
            html += '<div class="fw2-c' + (s[3] ? ' now' : '') + '">' + img + '<b>' + s[1] + '</b><span>' + s[2] + '</span></div>';
          });
          el.innerHTML = html + '</div>';
        });
      }
    }

    /* 20b-octies. Les cases de logos du groupe et l'atelier de Strasbourg */
    [['Logo Lima Protection','Lima Protection'],['Logo Lima Cyber','Lima Cyber'],['Logo Lima Cars','Lima Cars'],
     ['Logo Lima Shield','Lima Shield'],['Logo Lima Stratégie','Lima Stratégie']].forEach(function(cfg){
      phByText(cfg[0]).forEach(function(el){
        if (el.classList.contains('widgetized')) return;
        widgetize(el).classList.add('entite-tile');
        el.innerHTML = '<img src="' + window.LS_A + 'logo-lima-shield.png" alt=""><b>' + cfg[1] + '</b>';
      });
    });
    phByText('Photo atelier Strasbourg').forEach(function(el){
      if (el.classList.contains('swap-media') || el.classList.contains('widgetized')) return;
      fillImg(el, '' + window.LS_A + 'frise__proto-2025.jpg', '50% 50%', '300px');
    });

    /* 20c. Logos de sources officielles */
    var srcLogos = {
      "Logo du ministère de l'Intérieur": 'src-interieur.svg',
      'Logo de la source : Sénat': 'src-senat-1.png',
      'Logo de la source : FFB': 'src-ffb-0.png',
      'Logo de la source ]': 'src-ffb-0.png'
    };
    Object.keys(srcLogos).forEach(function(key){
      phByText(key.replace(' ]','')).forEach(function(el){
        if (el.classList.contains('widgetized')) return;
        widgetize(el).classList.add('srclogo');
        el.innerHTML = '<img src="' + window.LS_A + 'logos__' + srcLogos[key] + '" alt="">';
      });
    });

    /* 20d. Schéma 1-2-3 : les trois états, langage du kit */
    phByText('Schéma 1-2-3').forEach(function(el){
      widgetize(el).classList.add('states-w');
      var steps = [
        ['1', 'Désarmé', 'Le système veille, rien ne se déclenche.', 'off'],
        ['2', 'Armé', 'Détection infrarouge et thermique en service.', 'on'],
        ['3', 'Déclenché', 'Sommation par bips sonores, puis saturation sonore.', 'fire']
      ];
      var html = '<div class="st3">';
      steps.forEach(function(s){
        html += '<div class="st3-c ' + s[3] + '"><span class="st3-n">' + s[0] + '</span><b>' + s[1] + '</b><span class="st3-d">' + s[2] + '</span></div>';
      });
      el.innerHTML = html + '</div>';
    });

    /* Les trois états ont DÉJÀ leur composant (schéma 1-2-3). Partout où le fond les
       raconte autrement (étapes numérotées, titres en série), on rend le composant,
       avec les textes de la page. On ne redessine pas ce qui existe. */
    (function troisEtats(){
      if (document.querySelector('.states-w')) return;
      /* la page a-t-elle son propre emplacement pour ce composant ? alors il sera construit
         par la passe dédiée : on ne fabrique pas de doublon. */
      if (/Schéma 1-2-3/.test(document.body.textContent)) return;
      var noms = ['Désarmé', 'Armé', 'Déclenché'];
      var blocs = [];
      Array.prototype.forEach.call(document.querySelectorAll('h3, h4, b, strong'), function(t){
        var txt = t.textContent.replace(/[^A-Za-zÀ-ÿ]/g, '').trim();
        var i = noms.indexOf(txt);
        if (i === -1 || blocs[i]) return;
        blocs[i] = t;
      });
      if (blocs.filter(Boolean).length !== 3) return;
      var hote = blocs[0].closest('.etape') || blocs[0].parentNode;
      var conteneur = hote.parentNode;
      var textes = blocs.map(function(t){
        var bloc = t.closest('.etape') || t.parentNode;
        var p = bloc.querySelector('p');
        return p ? p.textContent.trim() : '';
      });
      var classes = ['off', 'on', 'fire'];
      var html = '<div class="st3">';
      noms.forEach(function(n, i){
        html += '<div class="st3-c ' + classes[i] + '"><span class="st3-n">' + (i + 1) + '</span>' +
                '<b>' + n + '</b><span class="st3-d">' + textes[i] + '</span></div>';
      });
      html += '</div>';
      var w = document.createElement('div');
      w.className = 'ph widgetized states-w';
      w.innerHTML = html;
      conteneur.insertBefore(w, hote);
      blocs.forEach(function(t){
        var bloc = t.closest('.etape') || t.parentNode;
        if (bloc && bloc.parentNode) bloc.parentNode.removeChild(bloc);
      });
    })();

    /* 20d-bis. Badges génériques : l'icône se déduit du libellé de la carte */
    var badgeIcons = {
      commercial: ['<path d="M3 12a9 9 0 1 0 2.6-6.4L3 8"/><path d="M3 3v5h5"/><path d="M12 8v4l2.8 1.7"/>', 'ok'],
      technique:  ['<path d="M12 3l7 3v5c0 5-3.5 8.5-7 10-3.5-1.5-7-5-7-10V6z"/><path d="M9 12l2 2 4.5-4.5"/>', 'brand'],
      abonnement: ['<rect x="2.5" y="6" width="19" height="12" rx="2"/><circle cx="12" cy="12" r="2.5"/><path d="M3 3l18 18"/>', 'neutral'],
      defaut:     ['<path d="M12 3l7 3v5c0 5-3.5 8.5-7 10-3.5-1.5-7-5-7-10V6z"/><path d="M9 12l2 2 4.5-4.5"/>', 'neutral']
    };
    all.forEach(function(el){
      if (el.classList.contains('widgetized') || el.classList.contains('swap-media')) return;
      if (el.textContent.replace(/[\[\]\s]/g, '') !== 'Badge') return;
      var host = el.parentNode ? el.parentNode.textContent.toLowerCase() : '';
      var key = host.indexOf('commercial') !== -1 ? 'commercial'
              : host.indexOf('technique') !== -1 ? 'technique'
              : host.indexOf('abonnement') !== -1 ? 'abonnement' : 'defaut';
      var cfg = badgeIcons[key];
      widgetize(el).classList.add('gbadge-inline');
      el.style.cssText = 'height:56px;width:56px;border:0;background:transparent;padding:0;box-shadow:none;margin-bottom:10px;';
      el.innerHTML = '<span class="g-badge ' + cfg[1] + '"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round">' + cfg[0] + '</svg></span>';
    });

    /* 20e. Badges de garantie nommés */
    [['Badge : Satisfait ou remboursé 30 jours', '30 jours', 'ok'],
     ['Badge : Garantie fabricant 2 ans', '2 ans', 'brand']].forEach(function(cfg){
      phByText(cfg[0]).forEach(function(el){
        if (el.classList.contains('widgetized')) return;
        widgetize(el).classList.add('gbadge-w');
        var ico = cfg[2] === 'ok'
          ? '<path d="M3 12a9 9 0 1 0 2.6-6.4L3 8"/><path d="M3 3v5h5"/><path d="M12 8v4l2.8 1.7"/>'
          : '<path d="M12 3l7 3v5c0 5-3.5 8.5-7 10-3.5-1.5-7-5-7-10V6z"/><path d="M9 12l2 2 4.5-4.5"/>';
        el.innerHTML = '<span class="g-badge ' + cfg[2] + '"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round">' + ico + '</svg></span><b class="gb-lbl">' + cfg[1] + '</b>';
      });
    });

    /* == TABLEAUX : une seule carte, coins arrondis tenus, sur toutes les pages ==
       Le fond pose border-collapse:collapse + un filet sur chaque cellule : avec ça,
       un border-radius sur la table ne rogne rien. On emballe donc chaque tableau
       dans une carte qui, elle, porte le rayon et découpe ce qui dépasse. */
    Array.prototype.forEach.call(document.querySelectorAll('table'), function(t){
      if (t.parentNode && t.parentNode.classList && t.parentNode.classList.contains('tbl-card')) return;
      var wrap = document.createElement('div');
      wrap.className = 'tbl-card';
      t.parentNode.insertBefore(wrap, t);
      wrap.appendChild(t);
      t.removeAttribute('style');
      Array.prototype.forEach.call(t.querySelectorAll('th, td'), function(c){ c.removeAttribute('style'); });
    });

    /* == 17b. Témoignages en ligne défilante (Projet 2) == */
    /* == PREUVES CLIENTS : une seule structure de carte, construite pareil sur toutes les pages == */
    function estCarteTemoignage(el){
      return /[Tt]émoignage à collecter/.test(el.textContent);
    }
    var groupesTemoignage = [];
    Array.prototype.forEach.call(document.querySelectorAll('div'), function(el){
      if (el.children.length < 2) return;
      var kids = Array.prototype.slice.call(el.children);
      if (kids.filter(estCarteTemoignage).length >= 2) groupesTemoignage.push(el);
    });
    /* Preuves clients RETIRÉES de toutes les pages tant que les témoignages ne sont pas
       collectés (Maurice, 2026-10-12). Si la section ne parle que d'eux (home), elle part
       entière ; sinon seul le bloc de cartes part, avec le titre posé juste avant lui.
       Le jour où les témoignages existent : supprimer ce bloc pour rétablir le carrousel. */
    groupesTemoignage.forEach(function(grp){
      var inner = grp.closest('.inner'), sec = grp.closest('section');
      var reste = inner ? Array.prototype.filter.call(inner.children, function(x){
        return x !== grp && !/^(H[1-4]|P)$/.test(x.tagName);
      }) : [grp];
      if (sec && sec.parentNode && !reste.length) { sec.parentNode.removeChild(sec); return; }
      var avant = grp.previousElementSibling;
      if (avant && /^H[1-4]$/.test(avant.tagName)) avant.parentNode.removeChild(avant);
      grp.parentNode.removeChild(grp);
    });
    groupesTemoignage = [];
    groupesTemoignage.forEach(function(grp){
      grp.classList.add('cards');
      /* PDF points 13 et 20 : jamais ce bloc sans son titre, et le titre doit être
         JUSTE avant lui, pas n'importe où dans la section. */
      /* le titre doit être JUSTE avant le bloc. Un titre plus haut appartient au bloc
         précédent (le mur des médias), il ne compte pas pour celui-ci. */
      /* un titre compte s'il est PROCHE du bloc (deux éléments au plus) et qu'aucun autre
         bloc majeur ne s'est intercalé entre lui et nous. Plus loin, il parle d'autre chose. */
      var aTitreT = false;
      var n = grp.previousElementSibling, saut = 0;
      while (n && saut < 2) {
        if (n.classList.contains('media-wall') || n.classList.contains('media-line')) break;
        if (/^H[1-4]$/.test(n.tagName)) { aTitreT = true; break; }
        n = n.previousElementSibling; saut++;
      }
      if (!aTitreT) {
        var hT = document.createElement('h2');
        hT.className = 'titre-injecte';
        hT.textContent = 'Ils ont installé un LIMA SHIELD.';
        grp.parentNode.insertBefore(hT, grp);
      }
      grp.removeAttribute('style');
      /* PRINCIPE DE COHÉRENCE : le bloc de preuves est celui de la home, à l'identique.
         Le fond de chaque page écrit ses propres témoignages ; on les remplace par les
         six de la page de vente pour que le bloc soit le même partout. */
      var PREUVES_HOME = [
        ['Stéphane', 'un des premiers à avoir adopté la solution',
         '[Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore. Témoignage à collecter.]'],
        ['Philippe', 'un LIMA SHIELD dans ses entrepôts, un autre chez lui',
         '[Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt. Témoignage à collecter.]'],
        ['Yoann', 'Yoann Le Meur, Medium, décembre 2025',
         '« Ce n\'est pas simplement une alarme qui retentit pour alerter, c\'est un véritable "bouclier sonore" qui vise à expulser l\'individu par la seule force du son. »'],
        ['[Prénom]', 'bijoutier',
         '[Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor. Témoignage à collecter.]'],
        ['[Prénom]', 'buraliste',
         '[Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod. Témoignage à collecter.]'],
        ['[Prénom]', 'mairie / police municipale',
         '[Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt. Témoignage à collecter.]']
      ];
      while (grp.children.length > PREUVES_HOME.length) grp.removeChild(grp.lastElementChild);
      while (grp.children.length < PREUVES_HOME.length) {
        grp.appendChild(grp.firstElementChild.cloneNode(true));
      }
      Array.prototype.forEach.call(grp.children, function(card, iCard){
        if (card.getAttribute('data-testi')) return;
        card.setAttribute('data-testi', '1');
        card.setAttribute('data-preuve', iCard);
        card.className = 'card';
        card.removeAttribute('style');
        /* le corps garde son HTML d'origine, sans les blocs d'image ni les étoiles déjà posées */
        /* on sépare ce que le fond écrit d'un bloc : le nom, son contexte, et le témoignage */
        var modele = PREUVES_HOME[iCard] || PREUVES_HOME[0];
        var nom = modele[0];
        var temoignage = modele[2];
        /* le rôle se lit sur le TEXTE, pas sur le HTML : sinon la virgule de liaison
           reste collée devant (« , un des premiers adoptants »). */
        var role = modele[1];
        /* ordre du modèle : photo, note, témoignage, nom */
        card.innerHTML =
          '<img class="testi-photo" src="' + window.LS_A + 'proof-placeholder.jpg" alt="">' +
          '<div class="testi-body">' +
            '<div class="fstars"><i>★</i><i>★</i><i>★</i><i>★</i><i>★</i></div>' +
            '<div class="testi-text">' + temoignage + '</div>' +
            '<div class="testi-who">' +
              '<img class="testi-avatar" src="' + window.LS_A + 'proof-placeholder.jpg" alt="">' +
              '<span><b>' + nom + '</b>' + (role ? '<em>' + role + '</em>' : '') + '</span>' +
            '</div>' +
          '</div>';
      });
    });

    /* PDF points 36-37, appliqué en fin de passe : sur la FAQ, aucune section sombre et
       aucun bloc de logos (« ils parlent de nous » est déjà en bas de page). */
    if (document.body.getAttribute('data-page') === 'page-faq-v1') {
      var premiereFaq = document.querySelector('section');
      Array.prototype.forEach.call(document.querySelectorAll('section.dark'), function(s){
        if (s === premiereFaq) return;          /* le haut de page reste noir, comme partout */
        s.classList.remove('dark'); s.removeAttribute('style');
      });
      if (premiereFaq) premiereFaq.classList.add('dark');
      var murFaq = document.querySelector('.media-wall');
      if (murFaq) {
        var sf = murFaq.closest('section');
        if (sf && sf.parentNode) sf.parentNode.removeChild(sf); else murFaq.parentNode.removeChild(murFaq);
      }
    }
    /* le schéma des trois états existe : la liste qui répète Désarmé / Armé / Déclenché
       en dessous fait doublon, on la retire. */
    if (document.querySelector('.states-w')) {
      var noms3 = ['Désarmé', 'Armé', 'Déclenché'];
      Array.prototype.forEach.call(document.querySelectorAll('.etape'), function(e){
        var t = e.querySelector('h3, h4, b, strong');
        if (!t) return;
        var txt = t.textContent.replace(/[^A-Za-zÀ-ÿ]/g, '').trim();
        if (noms3.indexOf(txt) !== -1) e.remove();
      });
    }
    listesDArguments();
    normaliseConteneurs();
    /* DOCTRINE (PDF feedback design, points répétés quinze fois) : par défaut, PAS
       d'encadré et PAS de ligne de démarcation. Du texte, organisé en listes.
       Gardent seuls leur encadré les vrais widgets : tuile de spécification à icône,
       carte de preuve, tableau, instruments, pricing. Tout le reste redevient du texte. */
    Array.prototype.forEach.call(document.querySelectorAll('.card2, .sys-tile, .choose > div, .cards2 > div, .comp, .encart'), function(c){
      if (c.closest('.car-wrap')) return;
      if (c.classList.contains('spec-tile') || c.closest('.kpis')) return;
      /* revue de presse : la grille entière est un widget. Si UNE carte de la grille porte
         un logo de média, TOUTES gardent leur encadré, sinon la grille devient un patchwork. */
      if (c.classList.contains('pr-card') || c.querySelector('.pr-logo')) return;
      if (c.parentNode && c.parentNode.querySelector('.pr-logo')) return;
      if (c.classList.contains('garantie') || c.querySelector('.g-badge')) return;  /* garanties : widget modèle */
      if (c.querySelector('.st3, .fw2, .mx-frame, .sw-plot, .tw-grid, .pm-phone, table')) return;
      c.classList.add('en-texte-bloc');
      var grille = c.parentNode;
      /* on ne déplie JAMAIS une grille qui contient un widget (revue de presse, garanties,
         tuiles de spécification) : seul le bloc de texte perd son encadré. */
      if (!grille) return;
      if (grille.querySelector('.pr-logo, .g-badge, .spec-tile, .ic-chip')) return;
      if (grille.children.length >= 2) grille.classList.add('en-texte');
    });
    /* Une LISTE À PUCES n'est pas une carte : l'encadré coupe les puces, qui débordent
       à gauche. Un bloc dont tout le contenu est une liste redevient du texte. */
    Array.prototype.forEach.call(document.querySelectorAll('.sys-tile, .card2, .cards2 > div, .choose > div, .spec-tile'), function(c){
      var listes = c.querySelectorAll(':scope > ul, :scope > ol');
      if (!listes.length) return;
      var texteHorsListe = c.textContent.length - Array.prototype.reduce.call(listes, function(n, l){ return n + l.textContent.length; }, 0);
      if (texteHorsListe > 30) return;
      c.classList.add('liste-nue');
    });
    /* Une pastille de frise porte une date, une pastille d'étape porte un numéro : la
       distinction se fait sur le CONTEXTE (le bloc .etape), jamais sur la longueur du
       texte, qui rangeait « 30 jours » avec les dates et « 2 ans » avec les numéros. */
    /* PDF point 28 : une année seule (« 2003 ») est une DATE, pas un numéro d'étape.
       Sans ça, sa pastille était plus petite que celle des « Années 1940 ». */
    Array.prototype.forEach.call(document.querySelectorAll('.etape .num'), function(n){
      var t = n.textContent.replace(/\s/g, '').trim();
      var estAnnee = /^\d{4}$/.test(t) && +t >= 1900;
      if (!/^\d{1,2}$/.test(t) || estAnnee) n.classList.add('num-date');
    });
    /* Le titre d'une garantie porte sa durée : « Garantie commerciale : 30 jours »,
       sur une seule ligne. La durée ne vit plus isolée au-dessus du titre. */
    Array.prototype.forEach.call(document.querySelectorAll('.garantie'), function(g){
      var num = g.querySelector('.num');
      var fort = g.querySelector('p strong, p b');
      if (!fort) return;
      var duree = num ? num.textContent.replace(/\s+/g, ' ').trim() : '';
      if (num) num.remove();
      if (!duree) duree = /commerciale/i.test(fort.textContent) ? '30 jours' : '2 ans';
      var base = fort.textContent.replace(/\s*[:.]\s*$/, '').trim();
      if (base.indexOf(':') === -1) fort.textContent = base + ' : ' + duree;
    });

    /* La durée est déjà dans le titre (« Garantie commerciale : 30 jours ») : le libellé
       posé sous la pastille par la passe des badges nommés fait doublon. */
    Array.prototype.forEach.call(document.querySelectorAll('.garantie .gb-lbl, .garantie .num'), function(n){ n.remove(); });
    espacesFines(document.body);
    equilibreLesGrilles();

    if (isP2 && !estComprendre && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      Array.prototype.forEach.call(document.querySelectorAll('.cards'), function(cards){
        var items = Array.prototype.slice.call(cards.children);
        if (items.length < 2) return;
        cards.classList.add('car-wrap');
        var track = document.createElement('div');
        track.className = 'car-track';
        items.forEach(function(c){ track.appendChild(c); });
        cards.appendChild(track);
        /* Boucle infinie. La série se mesure sur la largeur RÉELLE des cartes, jamais sur
           scrollWidth : au moment du déplacement, les cartes n'ont pas encore leur largeur
           et la série sortait à 508 px au lieu de 1880, d'où un saut en arrière toutes les
           vingt secondes (défaut relevé le 2026-09-01). Recalculée après le chargement des
           images et à chaque redimensionnement. */
        var gap = 16;
        function largeurSerie(){
          var l = 0;
          items.forEach(function(c){ l += c.getBoundingClientRect().width + gap; });
          return Math.round(l);
        }
        function poseLaBoucle(){
          Array.prototype.slice.call(track.querySelectorAll('[data-clone]')).forEach(function(c){ c.remove(); });
          var serie = largeurSerie();
          if (serie < 100) return;
          var besoin = serie + window.innerWidth + 200;
          var garde = 0;
          while (track.scrollWidth < besoin && garde < 12) {
            items.forEach(function(c){
              var cl = c.cloneNode(true);
              cl.setAttribute('data-clone', '1');
              track.appendChild(cl);
            });
            garde++;
          }
          track.style.setProperty('--serie', serie + 'px');
          track.style.animationDuration = Math.max(30, Math.round(serie / 26)) + 's';
        }
        poseLaBoucle();
        if (document.readyState !== 'complete') window.addEventListener('load', poseLaBoucle);
        var minuteur;
        window.addEventListener('resize', function(){ clearTimeout(minuteur); minuteur = setTimeout(poseLaBoucle, 200); });
      });
    }

  }

  /* Le menu ATELIER FORME se répare après tout script de page qui réécrirait les liens. */
  function healMenu(){
    var menu = document.getElementById('forme-menu');
    if (!menu) return;
    var base = (window.LS_PAGE || location.pathname.split('/').pop());
    var map = {'Origines': base, 'Projet 2': base + '?style=projet-2', 'Style Innovation': base + '?style=innovation'};
    Array.prototype.forEach.call(menu.querySelectorAll('a'), function(a){
      var label = (a.childNodes[0] && a.childNodes[0].nodeValue || '').trim();
      if (map[label]) a.setAttribute('href', map[label]);
    });
  }
  function scheduleHeal(){ setTimeout(healMenu, 0); setTimeout(healMenu, 250); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scheduleHeal);
  else scheduleHeal();

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
})();
